export const strCode = {
  LOGOUT_BTN: "LOGOUT_BTN",

  DARK_MODE_TOOLTIP: "DARK_MODE_TOOLTIP",
  LIGHT_MODE_TOOLTIP: "LIGHT_MODE_TOOLTIP",

  DASHBOARD_NAV_BTN: "DASHBOARD_NAV_BTN",
  USERS_NAV_BTN: "USERS_NAV_BTN",
  CONSENTS_NAV_BTN: "CONSENTS_NAV_BTN",
  SETTINGS_NAV_BTN: "SETTINGS_NAV_BTN",
  APPS_NAV_BTN: "APPS_NAV_BTN",
  NOTIFICATION_CENTER_NAV_BTN: "NOTIFICATION_CENTER_NAV_BTN",
  FLEET_MANAGEMENT_NAV_BTN: "FLEET_MANAGEMENT_NAV_BTN",
  HARDWARE_NAV_BTN: "HARDWARE_NAV_BTN",

  // Login Page
  SIMPLE_LOGIN_TITLE: "SIMPLE_LOGIN_TITLE",
  SIMPLE_LOGIN_DESCRIPTION: "SIMPLE_LOGIN_DESCRIPTION",
  NEW_PASSWORD_TITLE: "NEW_PASSWORD_TITLE",
  NEW_PASSWORD_DESCRIPTION: "NEW_PASSWORD_DESCRIPTION",
  SETUP_MFA_TITLE: "SETUP_MFA_TITLE",
  SETUP_MFA_DESCRIPTION: "SETUP_MFA_DESCRIPTION",
  ENTER_MFA_TITLE: "ENTER_MFA_TITLE",
  ENTER_MFA_DESCRIPTION: "ENTER_MFA_DESCRIPTION",
  FORGOT_PASSWORD_TITLE: "FORGOT_PASSWORD_TITLE",
  FORGOT_PASSWORD_DESCRIPTION: "FORGOT_PASSWORD_DESCRIPTION",
  RESET_PASSWORD_TITLE: "RESET_PASSWORD_TITLE",
  RESET_PASSWORD_DESCRIPTION: "RESET_PASSWORD_DESCRIPTION",
  SUCCESS_RESET_PASSWORD_TITLE: "SUCCESS_RESET_PASSWORD_TITLE",
  SELECT_MARKET_TITLE: "SELECT_MARKET_TITLE",
  SELECT_MARKET_DESCRIPTION: "SELECT_MARKET_DESCRIPTION",

  USERNAME_TITLE: "USERNAME_TITLE",
  USERNAME_PLACEHOLDER: "USERNAME_PLACEHOLDER",

  SURNAME_TITLE: "SURNAME_TITLE",

  PASSWORD_TITLE: "PASSWORD_TITLE",
  PASSWORD_PLACEHOLDER: "PASSWORD_PLACEHOLDER",

  NEW_PASSWORD_PLACEHOLDER: "NEW_PASSWORD_PLACEHOLDER",

  RE_ENTER_NEW_PASSWORD_TITLE: "RE_ENTER_NEW_PASSWORD_TITLE",

  PASSWORD_REQUIREMENTS_TITLE: "PASSWORD_REQUIREMENTS_TITLE",
  PASSWORD_LENGTH_REQUIREMENT: "PASSWORD_LENGTH_REQUIREMENT",
  PASSWORD_SPEC_SYMBOL_REQUIREMENT: "PASSWORD_SPEC_SYMBOL_REQUIREMENT",
  PASSWORD_BIG_SYMBOL_REQUIREMENT: "PASSWORD_BIG_SYMBOL_REQUIREMENT",
  PASSWORD_NUMBER_REQUIREMENT: "PASSWORD_NUMBER_REQUIREMENT",

  MFA_CODE_TITLE: "MFA_CODE_TITLE",
  MFA_CODE_PLACEHOLDER: "MFA_CODE_PLACEHOLDER",

  VERIFICATION_CODE_TITLE: "VERIFICATION_CODE_TITLE",
  VERIFICATION_CODE_PLACEHOLDER: "VERIFICATION_CODE_PLACEHOLDER",

  CONTINUE_BTN: "CONTINUE_BTN",
  FORGOT_PASSWORD_BTN: "FORGOT_PASSWORD_BTN",
  SEND_CODE_BTN: "SEND_CODE_BTN",
  BACK_TO_LOGIN_BTN: "BACK_TO_LOGIN_BTN",
  CHANGE_PASSWORD_BTN: "CHANGE_PASSWORD_BTN",
  RESEND_VERIFICATION_CODE_BTN: "RESEND_VERIFICATION_CODE_BTN",
  DIFFERENT_CREDENTIALS_BTN: "DIFFERENT_CREDENTIALS_BTN",
  SINGLE_SIGN_ON_BTN: "SINGLE_SIGN_ON_BTN",

  LOGIN_FAILED_ERROR: "LOGIN_FAILED_ERROR",
  USER_NOT_FOUND_ERROR: "USER_NOT_FOUND_ERROR",
  PASSWORD_NOT_EQUAL_ERROR: "PASSWORD_NOT_EQUAL_ERROR",
  INVALID_VERIFICARION_CODE_ERROR: "INVALID_VERIFICARION_CODE_ERROR",

  ERROR_INVALID_CODE: "ERROR_INVALID_CODE",
  ERROR_PASSWORD_OR_USER_NOT_EXIST: "ERROR_PASSWORD_OR_USER_NOT_EXIST",
  ERROR_SESSION_EXPIRED: "ERROR_SESSION_EXPIRED",
  ERROR_MFA_SESSION_EXPIRED: "ERROR_MFA_SESSION_EXPIRED",
  ERROR_USER_NOT_EXIST: "ERROR_USER_NOT_EXIST",
  ERROR_PASSWORD_NOT_EQUAL: "ERROR_PASSWORD_NOT_EQUAL",
  ERROR_INVALID_VERIFICARION_CODE: "ERROR_INVALID_VERIFICARION_CODE",
  ERROR_NO_ACCESS: "ERROR_NO_ACCESS",
  ERROR_ACCOUNT_LOCKED: "ERROR_ACCOUNT_LOCKED",

  ERROR: "ERROR",
  GLOBAL_ERROR: "GLOBAL_ERROR",
  SUCCESS: "SUCCESS",

  PASSWORD_SET_SUCCESS: "PASSWORD_SET_SUCCESS",
  PASSWORD_SET_SUCCESS_MESSAGE: "PASSWORD_SET_SUCCESS_MESSAGE",

  MFA_SETUP_TUTORIAL_TITLE: "MFA_SETUP_TUTORIAL_TITLE",
  MFA_SETUP_TUTORIAL_STEP1_TITLE: "MFA_SETUP_TUTORIAL_STEP1_TITLE",
  MFA_SETUP_TUTORIAL_STEP2_TITLE: "MFA_SETUP_TUTORIAL_STEP2_TITLE",

  CHOOSE_APPLICATION: "CHOOSE_APPLICATION",
  APPLICATION_TITLE: "APPLICATION_TITLE",

  SHOW_TITLE: "SHOW_TITLE",
  CHARTS_TITLE: "CHARTS_TITLE",

  IDLE_MODAL_TITLE: "IDLE_MODAL_TITLE",
  IDLE_MODAL_MESSAGE: "IDLE_MODAL_MESSAGE",

  STAY_LOGGED_IN_BTN: "STAY_LOGGED_IN_BTN",

  APP_VERSION_MODAL_TITLE: "APP_VERSION_MODAL_TITLE",
  APP_VERSION_MODAL_MESSAGE: "APP_VERSION_MODAL_MESSAGE",

  REFRESH_NOW_BTN: "REFRESH_NOW_BTN",
  REMIND_LATER_BTN: "REMIND_LATER_BTN",

  COPYRIGHT_NOTICE: "COPYRIGHT_NOTICE",

  // User Management Page
  USER_MANAGEMENT_TITLE: "USER_MANAGEMENT_TITLE",
  CREATE_USER_TITLE: "CREATE_USER_TITLE",
  CREATE_IAP_USER_TITLE: "CREATE_IAP_USER_TITLE",
  USER_TITLE: "USER_TITLE",

  USERS_FETCH_ERROR: "USERS_FETCH_ERROR",
  USER_FETCH_ERROR: "USER_FETCH_ERROR",

  MARKETS_FETCH_ERROR: "MARKETS_FETCH_ERROR",

  USERS_BACK_BTN: "USERS_BACK_BTN",

  // TODO: check and change text info
  FETCH_USERS_ERROR: "FETCH_USERS_ERROR",
  IMPORT_USERS_ERROR: "IMPORT_USERS_ERROR",
  IMPORT_USERS_SUCCESS: "IMPORT_USERS_SUCCESS",
  IMPORT_USERS_SUCCESS_INFO: "IMPORT_USERS_SUCCESS_INFO",

  CREATE_USER_ERROR: "CREATE_USER_ERROR",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_SUCCESS_INFO: "CREATE_USER_SUCCESS_INFO",

  FETCH_USER_ERROR: "FETCH_USER_ERROR",
  UPDATE_USER_ERROR: "UPDATE_USER_ERROR",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_SUCCESS_INFO: "UPDATE_USER_SUCCESS_INFO",

  DELETE_USER_ERROR: "DELETE_USER_ERROR",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_SUCCESS_INFO: "DELETE_USER_SUCCESS_INFO",

  RESET_USER_PASSWORD_ERROR: "RESET_USER_PASSWORD_ERROR",
  RESET_USER_PASSWORD_SUCCESS: "RESET_USER_PASSWORD_SUCCESS",
  RESET_USER_PASSWORD_SUCCESS_INFO: "RESET_USER_PASSWORD_SUCCESS_INFO",

  DELETE_LOCATION_SUCCESS_INFO: "DELETE_LOCATION_SUCCESS_INFO",
  DELETE_LOCATION_ERROR: "DELETE_LOCATION_ERROR",

  FILTER_TITLE: "FILTER_TITLE",

  ALL_FILTER_BTN: "ALL_FILTER_BTN",
  ACTIVE_FILTER_BTN: "ACTIVE_FILTER_BTN",
  INACTIVE_FILTER_BTN: "INACTIVE_FILTER_BTN",

  EXPIRES_SOON_INFO: "EXPIRES_SOON_INFO",

  SEARCH_BY_USERNAME_PLACEHOLDER: "SEARCH_BY_USERNAME_PLACEHOLDER",

  NEW_BTN: "NEW_BTN",
  USER_BTN: "USER_BTN",
  IAP_USER_BTN: "IAP_USER_BTN",
  BATCH_CREATE_BTN: "BATCH_CREATE_BTN",

  HISTORY_TITLE: "HISTORY_TITLE",
  HISTORY_LOG_TITLE: "HISTORY_LOG_TITLE",
  VIEV_IN_DIALOG_TOOLTIP: "VIEV_IN_DIALOG_TOOLTIP",

  LATEST_FIRST_OPTION: "LATEST_FIRST_OPTION",
  OLDEST_FIRST_OPTION: "OLDEST_FIRST_OPTION",

  OWNER_TITLE: "OWNER_TITLE",
  ROLES_TITLE: "ROLES_TITLE",
  MARKET_TITLE: "MARKET_TITLE",
  STATUS_TITLE: "STATUS_TITLE",
  APP_TYPES_TITLE: "APP_TYPES_TITLE",
  CHANNELS_TITLE: "CHANNELS_TITLE",
  SWITCH_APPLICATION_TITLE: "SWITCH_APPLICATION_TITLE",
  SWITCH_APP_TITLE: "SWITCH_APP_TITLE",

  ROLE_SETTINGS_TITLE: "ROLE_SETTINGS_TITLE",
  ACCESS_TYPE_LABEL: "ACCESS_TYPE_LABEL",
  ROLES_LABEL: "ROLES_LABEL",
  APPLICATIONS_LABEL: "APPLICATIONS_LABEL",
  MARKETS_LABEL: "MARKETS_LABEL",
  DEVICES_LABEL: "DEVICES_LABEL",

  NO_USERNAME_FOUND: "NO_USERNAME_FOUND",
  CHECK_USERNAME_MESSAGE: "CHECK_USERNAME_MESSAGE",
  NO_DATA: "NO_DATA",

  NO_MARKET_CODE_FOUND: "NO_MARKET_CODE_FOUND",
  CHECK_MARKET_CODE_MESSAGE: "CHECK_MARKET_CODE_MESSAGE",

  NO_APP_NAME_FOUND: "NO_APP_NAME_FOUND",
  CHECK_APP_NAME_MESSAGE: "CHECK_APP_NAME_MESSAGE",

  ROWS_PER_PAGE: "ROWS_PER_PAGE",
  OF: "OF",

  BASIC_INFO_TITLE: "BASIC_INFO_TITLE",
  ROLE_TITLE: "ROLE_TITLE",
  MARKETS_TITLE: "MARKETS_TITLE",
  STORES_TITLE: "STORES_TITLE",
  APP_AND_MARKET_SETTINGS_TITLE: "APP_AND_MARKET_SETTINGS_TITLE",
  APP_MUST_BE_SELECTED: "APP_MUST_BE_SELECTED",

  MARKET_MUST_BE_SELECTED: "MARKET_MUST_BE_SELECTED",

  LOCATION_TITLE: "LOCATION_TITLE",
  LOCATIONS_TITLE: "LOCATIONS_TITLE",

  SELECT_LOCATION_TITLE: "SELECT_LOCATION_TITLE",

  CREATED_ON_INFO: "CREATED_ON_INFO",
  LAST_LOGGED_IN_INFO: "LAST_LOGGED_IN_INFO",

  TODAY: "TODAY",
  YESTERDAY: "YESTERDAY",

  EMAIL_TITLE: "EMAIL_TITLE",

  SMART_DASHBOARDS: "SMART_DASHBOARDS",

  ACTIVE_FROM_TITLE: "ACTIVE_FROM_TITLE",
  ACTIVE_TO_TITLE: "ACTIVE_TO_TITLE",
  UNTIL_TITLE: "UNTIL_TITLE",

  DATE_INPUT_PLACEHOLER: "DATE_INPUT_PLACEHOLER",

  SEARCH_FOR_ROLES_PLACEHOLDER: "SEARCH_FOR_ROLES_PLACEHOLDER",
  ADD_ROLE_BTN: "ADD_ROLE_BTN",

  SELECT_MARKETS_TITLE: "SELECT_MARKETS_TITLE",
  SEARCH_FOR_MARKETS_PLACEHOLDER: "SEARCH_FOR_MARKETS_PLACEHOLDER",

  SELECT_STORE_TITLE: "SELECT_STORE_TITLE",
  STORE_TITLE: "STORE_TITLE",
  SEARCH_FOR_STORES_PLACEHOLDER: "SEARCH_FOR_STORES_PLACEHOLDER",

  SELECT_APPS_TITLE: "SELECT_APPS_TITLE",
  SELECT_APP_PLACEHOLDER: "SELECT_APP_PLACEHOLDER",
  SELECT_ROLE_PLACEHOLDER: "SELECT_ROLE_PLACEHOLDER",

  NO_OPTIONS_AVAILABLE: "NO_OPTIONS_AVAILABLE",

  OPTIONAL_LOCATION_INFO: "OPTIONAL_LOCATION_INFO",
  DISABLED_LOCATION_INFO: "DISABLED_LOCATION_INFO",

  ROLE_DUPLICATION_ERROR_TITLE: "ROLE_DUPLICATION_ERROR_TITLE",
  ROLE_DUPLICATION_ERROR_MESSAGE: "ROLE_DUPLICATION_ERROR_MESSAGE",

  REMOVE_USER_BTN: "REMOVE_USER_BTN",
  RESET_USERS_PASSWORD_BTN: "RESET_USERS_PASSWORD_BTN",
  CANCEL_BTN: "CANCEL_BTN",
  DONE_BTN: "DONE_BTN",
  SUBMIT_BTN: "SUBMIT_BTN",
  DELETE_BTN: "DELETE_BTN",
  RESET_BTN: "RESET_BTN",
  SAVE_CHANGES_BTN: "SAVE_CHANGES_BTN",

  RESET_TO_DEFAULT: "RESET_TO_DEFAULT",

  DELETE_USER_CONFIRMATION_TITLE: "DELETE_USER_CONFIRMATION_TITLE",
  DELETE_USER_CONFIRMATION_TEXT: "DELETE_USER_CONFIRMATION_TEXT",
  RESET_USERS_PASSWORD_CONFIRMATION_TITLE: "RESET_USERS_PASSWORD_CONFIRMATION_TITLE",
  RESET_USERS_PASSWORD_CONFIRMATION_TEXT: "RESET_USERS_PASSWORD_CONFIRMATION_TEXT",

  EMPTY_FILE_ERROR_TITLE: "EMPTY_FILE_ERROR_TITLE",
  EMPTY_FILE_ERROR_MESSAGE: "EMPTY_FILE_ERROR_MESSAGE",
  FILE_IMPORT_ERROR_TITLE: "FILE_IMPORT_ERROR_TITLE",
  FILE_IMPORT_ERROR_MESSAGE: "FILE_IMPORT_ERROR_MESSAGE",
  FILE_FORMAT_ERROR_TITLE: "FILE_FORMAT_ERROR_TITLE",
  FILE_FORMAT_ERROR_MESSAGE: "FILE_FORMAT_ERROR_MESSAGE",

  FILE_SIZE_ERROR_TITLE: "FILE_SIZE_ERROR_TITLE",
  FILE_SIZE_ERROR_MESSAGE: "FILE_SIZE_ERROR_MESSAGE",

  IMPORTING_INFO: "IMPORTING_INFO",

  DRAG_AND_DROP_INFO: "DRAG_AND_DROP_INFO",
  CHOOSE_FILE_BTN: "CHOOSE_FILE_BTN",
  SUPPORTED_FORMATS_INFO: "SUPPORTED_FORMATS_INFO",
  DROP_FILE_INFO: "DROP_FILE_INFO",

  TABLE_EXAMPLE_TITLE: "TABLE_EXAMPLE_TITLE",
  TABLE_EXAMPLE_INFO: "TABLE_EXAMPLE_INFO",
  DOWNLOAD_BTN: "DOWNLOAD_BTN",

  IMPORTING_SUMMARY_TITLE: "IMPORTING_SUMMARY_TITLE",
  SUCCESSFUL_IMPORT_TITLE: "SUCCESSFUL_IMPORT_TITLE",
  PARTIALY_SUCCESSFUL_IMPORT_TITLE: "PARTIALY_SUCCESSFUL_IMPORT_TITLE",
  FAILED_IMPORT_TITLE: "FAILED_IMPORT_TITLE",

  SUCCESSFUL_USERS_IMPORT_INFO: "SUCCESSFUL_USERS_IMPORT_INFO",
  FAILED_USERS_IMPORT_INFO: "FAILED_USERS_IMPORT_INFO",

  CORRECT_RECORDS: "CORRECT_RECORDS",
  INCORRECT_RECORDS: "INCORRECT_RECORDS",

  MISSING_DATA_BTN: "MISSING_DATA_BTN",
  READY_FOR_IMPORT_BTN: "READY_FOR_IMPORT_BTN",

  DOWNLOAD_CSV_BTN: "DOWNLOAD_CSV_BTN",
  DOWNLOAD_DOT_CSV: "DOWNLOAD_DOT_CSV",
  CANCEL_IMPORT_BTN: "CANCEL_IMPORT_BTN",
  IMPORT_GOOD_BTN: "IMPORT_GOOD_BTN",
  IMPORT_BTN: "IMPORT_BTN",

  EMPTY_CELL_INFO: "EMPTY_CELL_INFO",

  LOCATION_MANAGEMENT_SELECT_ONE_MARKET_MSG: "LOCATION_MANAGEMENT_SELECT_ONE_MARKET_MSG",
  LOCATION_MANAGEMENT_TOO_MANY_MARKETS_MSG: "LOCATION_MANAGEMENT_TOO_MANY_MARKETS_MSG",

  // User Change History
  HISTORY_FETCH_ERROR: "HISTORY_FETCH_ERROR",

  CREATED_USER_ACCOUNT_ACTION: "CREATED_USER_ACCOUNT_ACTION",
  DELETED_USER_ACCOUNT_ACTION: "DELETED_USER_ACCOUNT_ACTION",
  ADDED_CHANGES_ACTION: "ADDED_CHANGES_ACTION",
  RESET_PASSWORD_ACTION: "RESET_PASSWORD_ACTION",

  ACCOUNT_CREATED_ACTION: "ACCOUNT_CREATED_ACTION",
  PASSWORD_RESET_ACTION: "PASSWORD_RESET_ACTION",
  ACCOUNT_DELETED_ACTION: "ACCOUNT_DELETED_ACTION",
  CHANGED_ATTRIBUTE_ACTION: "CHANGED_ATTRIBUTE_ACTION",
  ADDED_ATTRIBUTE_ACTION: "ADDED_ATTRIBUTE_ACTION",
  REMOVED_ATTRIBUTE_ACTION: "REMOVED_ATTRIBUTE_ACTION",
  ENABLED_ATTRIBUTE_ACTION: "ENABLED_ATTRIBUTE_ACTION",
  DISABLED_ATTRIBUTE_ACTION: "DISABLED_ATTRIBUTE_ACTION",

  ROLE_ACTION_INFO: "ROLE_ACTION_INFO",
  APPLICATION_ACTION_INFO: "APPLICATION_ACTION_INFO",
  APPLICATION_REMOVE_ACTION_INFO: "APPLICATION_REMOVE_ACTION_INFO",

  FIRST_NAME_ATTR: "FIRST_NAME_ATTR",
  LAST_NAME_ATTR: "LAST_NAME_ATTR",
  EMAIL_ATTR: "EMAIL_ATTR",
  APPLICATION_ATTR: "APPLICATION_ATTR",
  MARKET_ATTR: "MARKET_ATTR",
  LOCATION_ATTR: "LOCATION_ATTR",
  ROLE_ATTR: "ROLE_ATTR",
  ACTIVE_FROM_ATTR: "ACTIVE_FROM_ATTR",
  ACTIVE_TO_ATTR: "ACTIVE_TO_ATTR",

  // Stores
  SEARCH_BY_STORE_NAME_PLACEHOLDER: "SEARCH_BY_STORE_NAME_PLACEHOLDER",
  SEARCH_LOCATIONS_PLACEHOLDER: "SEARCH_LOCATIONS_PLACEHOLDER",
  LOCATIONS_FETCH_ERROR: "LOCATIONS_FETCH_ERROR",

  STORE_NAME_TITLE: "STORE_NAME_TITLE",
  LOCATION_NAME_TITLE: "LOCATION_NAME_TITLE",
  ADDRESS_TITLE: "ADDRESS_TITLE",
  ADDRESS_PLACEHOLDER: "ADDRESS_PLACEHOLDER",
  CITY_TITLE: "CITY_TITLE",

  NO_STORES_DATA: "NO_STORES_DATA",

  NO_STORES_FOUND: "NO_STORES_FOUND",
  CHECK_STORE_MESSAGE: "CHECK_STORE_MESSAGE",

  FETCH_STORES_ERROR: "FETCH_STORES_ERROR",

  CREATE_LOCATION_SUCCESS_TITLE: "CREATE_LOCATION_SUCCESS_TITLE",
  CREATE_LOCATION_SUCCESS_MESSAGE: "CREATE_LOCATION_SUCCESS_MESSAGE",

  EDIT_LOCATION_SUCCESS_TITLE: "EDIT_LOCATION_SUCCESS_TITLE",
  EDIT_LOCATIONS_SUCCESS_MESSAGE: "EDIT_LOCATIONS_SUCCESS_MESSAGE",

  EDIT_LOCATION_ERROR_TITLE: "EDIT_LOCATION_ERROR_TITLE",

  // Dashboard Page
  DASHBOARD_TITLE: "DASHBOARD_TITLE",
  REFRESH_BTN: "REFRESH_BTN",
  LOADING: "LOADING",
  DASHBOARD_FETCH_ERROR: "DASHBOARD_FETCH_ERROR",
  NO_EVENTS_INFO: "NO_EVENTS_INFO",
  NO_DATA_FOR_CHART: "NO_DATA_FOR_CHART",

  PAGE_LOADS_TITLE: "PAGE_LOADS_TITLE",
  AVG_PAGE_LOAD_SPEED_TITLE: "AVG_PAGE_LOAD_SPEED_TITLE",
  IQOS_DEVICE_USAGE: "IQOS_DEVICE_USAGE",
  IQOS_DEVICE_CONNECTIONS_TITLE: "IQOS_DEVICE_CONNECTIONS_TITLE",
  DIAGNOSTICS_PERFORMANCE_TITLE: "DIAGNOSTICS_PERFORMANCE_TITLE",
  SETTING_USAGE_TITLE: "SETTING_USAGE_TITLE",
  SETTING_PERFOMANCE_TITLE: "SETTING_PERFOMANCE_TITLE",
  FWU_STATISTICS_TITLE: "FWU_STATISTICS_TITLE",
  FWU_STATISTICS_SHORT_TITLE: "FWU_STATISTICS_SHORT_TITLE",
  FWU_PERFORMANCE_TITLE: "FWU_PERFORMANCE_TITLE",
  FWU_PERFORMANCE_SHORT_TITLE: "FWU_PERFORMANCE_SHORT_TITLE",
  FWU_ERRORS_TITLE: "FWU_ERRORS_TITLE",
  FWU_ERRORS_SHORT_TITLE: "FWU_ERRORS_SHORT_TITLE",
  RECONNECTION_TIME_DURING_FWU_TITLE: "RECONNECTION_TIME_DURING_FWU_TITLE",
  CONNECTION_TIME_TITLE: "CONNECTION_TIME_TITLE",
  AD_STATISTICS_TITLE: "AD_STATISTICS_TITLE",
  AD_STATISTICS_SHORT_TITLE: "AD_STATISTICS_SHORT_TITLE",
  FWU_COUNT_TITLE: "FWU_COUNT_TITLE",
  FWU_COUNT_SHORT_TITLE: "FWU_COUNT_SHORT_TITLE",
  FWU_COUNT_PER_LOCATION_TITLE: "FWU_COUNT_PER_LOCATION_TITLE",
  FWU_COUNT_PER_APPLICATION_TITLE: "FWU_COUNT_PER_APPLICATION_TITLE",
  AD_COUNT_TITLE: "AD_COUNT_TITLE",
  AD_COUNT_PER_LOCATION_TITLE: "AD_COUNT_PER_LOCATION_TITLE",
  OPERATING_SYSTEM_USAGE_TITLE: "OPERATING_SYSTEM_USAGE_TITLE",
  BROWSER_USAGE_TITLE: "BROWSER_USAGE_TITLE",
  AD_COUNT_PER_APPLICATION_TITLE: "AD_COUNT_PER_APPLICATION_TITLE",
  BATTERY_HEALTH_STATISTICS_TITLE: "BATTERY_HEALTH_STATISTICS_TITLE",
  BATTERY_HEALTH_PERFORMANCE_TITLE: "BATTERY_HEALTH_PERFORMANCE_TITLE",
  DIAGNOSTIC_ERRORS_READING_PEROFOMANCE_TITLE: "DIAGNOSTIC_ERRORS_READING_PEROFOMANCE_TITLE",

  COUNT_LABEL: "COUNT_LABEL",
  MAX_COUNT_LABEL: "MAX_COUNT_LABEL",
  MAX_AVG_COUNT_LABEL: "MAX_AVG_COUNT_LABEL",
  SPEED_LABEL: "SPEED_LABEL",
  MAX_AVG_SPEED_LABEL: "MAX_AVG_SPEED_LABEL",
  TIME_LABEL: "TIME_LABEL",
  MAX_AVG_TIME_LABEL: "MAX_AVG_TIME_LABEL",
  AVERAGE_LABEL: "AVERAGE_LABEL",
  MAX_AVERAGE_LABEL: "MAX_AVERAGE_LABEL",

  PAGE_LOADS_LABEL: "PAGE_LOADS_LABEL",
  DURATION_LABEL: "DURATION_LABEL",
  DIAGNOSTICS_LABEL: "DIAGNOSTICS_LABEL",
  ALL_DEVICES_LABEL: "ALL_DEVICES_LABEL",
  SUCCESSFUL_FWU_LABEL: "SUCCESSFUL_FWU_LABEL",
  SUCCESSFUL_NOT_RECONNECTED_FWU_LABEL: "SUCCESSFUL_NOT_RECONNECTED_FWU_LABEL",
  FAILED_FWU_LABEL: "FAILED_FWU_LABEL",
  AMOUNT_OF_FWU_LABEL: "AMOUNT_OF_FWU_LABEL",
  GENERAL_FWU_ERRORS_LABEL: "GENERAL_FWU_ERRORS_LABEL",
  TIMEOUT_FWU_ERRORS_LABEL: "TIMEOUT_FWU_ERRORS_LABEL",
  CM_FWU_ERRORS_LABEL: "CM_FWU_ERRORS_LABEL",
  BATTERY_FWU_ERRORS_LABEL: "BATTERY_FWU_ERRORS_LABEL",
  OTHER_FWU_ERRORS_LABEL: "OTHER_FWU_ERRORS_LABEL",
  MONO_DEVICES_LABEL: "MONO_DEVICES_LABEL",
  KIT_LABEL: "KIT_LABEL",
  CHARGER_LABEL: "CHARGER_LABEL",
  HOLDER_LABEL: "HOLDER_LABEL",
  MONO_LABEL: "MONO_LABEL",
  DUO_DEVICES_LABEL: "DUO_DEVICES_LABEL",
  CONNECTIONS_LABEL: "CONNECTIONS_LABEL",
  WORKING_PROPERLY_LABEL: "WORKING_PROPERLY_LABEL",
  DEFECTIVE_LABEL: "DEFECTIVE_LABEL",
  FAILED_LABEL: "FAILED_LABEL",
  UNKNOWN_LABEL: "UNKNOWN_LABEL",
  UNDEFINED_LABEL: "UNDEFINED_LABEL",
  SUCCESSFUL_LABEL: "SUCCESSFUL_LABEL",
  BATTERY_HEALTH_LABEL: "BATTERY_HEALTH_LABEL",

  TODAY_OPTION: "TODAY_OPTION",
  THIS_WEEK_OPTION: "THIS_WEEK_OPTION",
  THIS_MONTH_OPTION: "THIS_MONTH_OPTION",
  THIS_YEAR_OPTION: "THIS_YEAR_OPTION",
  LAST_24_HOURS_OPTION: "LAST_24_HOURS_OPTION",
  LAST_7_DAYS_OPTION: "LAST_7_DAYS_OPTION",
  LAST_30_DAYS_OPTION: "LAST_30_DAYS_OPTION",
  LAST_12_MONTHS_OPTION: "LAST_12_MONTHS_OPTION",
  RANGE_OPTION: "RANGE_OPTION",

  DEVICE_TITLE: "DEVICE_TITLE",
  OPERATING_SYSTEM_TITLE: "OPERATING_SYSTEM_TITLE",
  DATE_RANGE_TITLE: "DATE_RANGE_TITLE",
  CONNECTIVITY_TITLE: "CONNECTIVITY_TITLE",

  BROWSER_TITLE: "BROWSER_TITLE",

  FROM_TITLE: "FROM_TITLE",
  TO_TITLE: "TO_TITLE",

  APPLY_BTN: "APPLY_BTN",

  OVERVIEW: "OVERVIEW",
  FIRMWARE: "FIRMWARE",
  FIRMWARES_TITLE: "FIRMWARES_TITLE",
  DIAGNOSTIC: "DIAGNOSTIC",
  SETTINGS: "SETTINGS",
  BATTERY_HEALTH: "BATTERY_HEALTH",

  TOTAL_TITLE: "TOTAL_TITLE",

  LED_MODE_COUNT_LABEL: "LED_MODE_COUNT_LABEL",
  VIBRATION_MODE_COUNT_LABEL: "VIBRATION_MODE_COUNT_LABEL",
  CLEANING_MODE_COUNT_LABEL: "CLEANING_MODE_COUNT_LABEL",
  RESPONSIVE_DRAW_COUNT_LABEL: "RESPONSIVE_DRAW_COUNT_LABEL",
  VAPE_CLOUD_SIZE_COUNT_LABEL: "VAPE_CLOUD_SIZE_COUNT_LABEL",
  AUTO_START_COUNT_LABEL: "AUTO_START_COUNT_LABEL",
  SMART_GESTURES_COUNT_LABEL: "SMART_GESTURES_COUNT_LABEL",
  RESTART_MODE_COUNT_LABEL: "RESTART_MODE_COUNT_LABEL",

  DASHBOARD_FILTERS_SECTION: "DASHBOARD_FILTERS_SECTION",
  APP_AND_MARKET_FILTERS_SECTION: "APP_AND_MARKET_FILTERS_SECTION",
  PLATFORM_AND_CONNECTIVITY_FILTERS_SECTION: "PLATFORM_AND_CONNECTIVITY_FILTERS_SECTION",

  // Consent Management Page
  CONSENT_MANAGEMENT_TITLE: "CONSENT_MANAGEMENT_TITLE",
  CONSENT_VERSION_TITLE: "CONSENT_VERSION_TITLE",
  NEW_CONSENT_VERSION_TITLE: "NEW_CONSENT_VERSION_TITLE",
  DUPLICATE_CONSENT_VERSION_TITLE: "DUPLICATE_CONSENT_VERSION_TITLE",
  DRAFT_CONSENT_POSITION_TITLE: "DRAFT_CONSENT_POSITION_TITLE",

  VIEW_CONSENT_ELEMENT: "VIEW_CONSENT_ELEMENT",
  EDIT_CONSENT_ELEMENT: "EDIT_CONSENT_ELEMENT",
  NEW_CONSENT_ELEMENT: "NEW_CONSENT_ELEMENT",

  DRAFTS: "DRAFTS",

  FETCH_CONSENTS_ERROR: "FETCH_CONSENTS_ERROR",
  FETCH_CONSENT_ERROR: "FETCH_CONSENT_ERROR",
  PUBLISH_CONSENT_ERROR: "PUBLISH_CONSENT_ERROR",
  UPDATE_CONSENT_ERROR: "UPDATE_CONSENT_ERROR",
  ACTIVATE_CONSENT_ERROR: "ACTIVATE_CONSENT_ERROR",
  ACTIVATE_CONSENT_SUCCESS: "ACTIVATE_CONSENT_SUCCESS",
  DELETE_CONSENT_ERROR: "DELETE_CONSENT_ERROR",
  UPDATE_CONSENT_SUCCESS: "UPDATE_CONSENT_SUCCESS",

  CONSENTS_FETCH_ERROR: "CONSENTS_FETCH_ERROR",
  CONSENT_FETCH_ERROR: "CONSENT_FETCH_ERROR",

  CONSENT_UPDATE_SUCCESS: "CONSENT_UPDATE_SUCCESS",
  CONSENT_ACTIVATE_SUCCESS: "CONSENT_ACTIVATE_SUCCESS",

  DISCARD_BTN: "DISCARD_BTN",
  SAVE_DRAFT_BTN: "SAVE_DRAFT_BTN",
  SAVE_AND_ACTIVATE_BTN: "SAVE_AND_ACTIVATE_BTN",
  SAVE_AND_CLOSE_BTN: "SAVE_AND_CLOSE_BTN",
  BACK_TO_OVERVIEW_BTN: "BACK_TO_OVERVIEW_BTN",

  CREATE_BTN: "CREATE_BTN",
  DUPLICATE_BTN: "DUPLICATE_BTN",

  ACTIVATE_MODAL_TITLE: "ACTIVATE_MODAL_TITLE",
  ACTIVATE_MODAL_TEXT: "ACTIVATE_MODAL_TEXT",
  ACTIVATE_MODAL_THIS_VERSION_TEXT: "ACTIVATE_MODAL_THIS_VERSION_TEXT",

  ACTIVATE_NOW_BTN: "ACTIVATE_NOW_BTN",
  SAVE_DRAFT_INSTEAD_BTN: "SAVE_DRAFT_INSTEAD_BTN",

  VERSION_TITLE: "VERSION_TITLE",
  MODIFIED_BY_TITLE: "MODIFIED_BY_TITLE",
  ACTIVATED_TITLE: "ACTIVATED_TITLE",
  DEACTIVATED_TITLE: "DEACTIVATED_TITLE",
  LAST_MODIFIED_TITLE: "LAST_MODIFIED_TITLE",

  NAME_TITLE: "NAME_TITLE",
  VALUE_TITLE: "VALUE_TITLE",
  GROUP_TITLE: "GROUP_TITLE",
  POSITION_TITLE: "POSITION_TITLE",
  CREATED_TITLE: "CREATED_TITLE",
  MODIFIED_TITLE: "MODIFIED_TITLE",
  TYPE_TITLE: "TYPE_TITLE",
  ATTRIBUTE_TITLE: "ATTRIBUTE_TITLE",

  DRAFT_BTN: "DRAFT_BTN",

  NO_CONSENTS_DATA: "NO_CONSENTS_DATA",
  NO_DRAFTS_DATA: "NO_DRAFTS_DATA",
  NO_CONSENT_ELEMENTS_DATA: "NO_CONSENT_ELEMENTS_DATA",

  GROUP_NAME_TITLE: "GROUP_NAME_TITLE",
  ATTRIBUTES_TITLE: "ATTRIBUTES_TITLE",
  CONSENT_FLAGS_TITLE: "CONSENT_FLAGS_TITLE",
  CONSENT_VISIBLE_TITLE: "CONSENT_VISIBLE_TITLE",

  CONSENT_GROUP_RETAIL_TNC: "CONSENT_GROUP_RETAIL_TNC",
  CONSENT_GROUP_DIAGNOSTIC_TNC: "CONSENT_GROUP_DIAGNOSTIC_TNC",

  CONSENT_ATTRIBUTE_ACCESS_TNC: "CONSENT_ATTRIBUTE_ACCESS_TNC",
  CONSENT_ATTRIBUTE_COLLECTING_TNC: "CONSENT_ATTRIBUTE_COLLECTING_TNC",
  CONSENT_ATTRIBUTE_DESCRIPTION: "CONSENT_ATTRIBUTE_DESCRIPTION",

  CONSENT_TYPE_INFORMATIONAL: "CONSENT_TYPE_INFORMATIONAL",
  CONSENT_TYPE_MANDATORY: "CONSENT_TYPE_MANDATORY",
  CONSENT_TYPE_NOT_MANDATORY: "CONSENT_TYPE_NOT_MANDATORY",

  XP_PIR_DESCRIPTION: "XP_PIR_DESCRIPTION",
  XP_PIA_DESCRIPTION: "XP_PIA_DESCRIPTION",
  XP_MSG_DESCRIPTION: "XP_MSG_DESCRIPTION",
  XP_DIA_DESCRIPTION: "XP_DIA_DESCRIPTION",
  XP_SELF_DESCRIPTION: "XP_SELF_DESCRIPTION",

  EVENTS_PIR_DESCRIPTION: "EVENTS_PIR_DESCRIPTION",
  EVENTS_PIA_DESCRIPTION: "EVENTS_PIA_DESCRIPTION",
  EVENTS_MSG_DESCRIPTION: "EVENTS_MSG_DESCRIPTION",
  EVENTS_DIA_DESCRIPTION: "EVENTS_DIA_DESCRIPTION",
  EVENTS_SELF_DESCRIPTION: "EVENTS_SELF_DESCRIPTION",

  ERRORS_PIR_DESCRIPTION: "ERRORS_PIR_DESCRIPTION",
  ERRORS_PIA_DESCRIPTION: "ERRORS_PIA_DESCRIPTION",
  ERRORS_MSG_DESCRIPTION: "ERRORS_MSG_DESCRIPTION",
  ERRORS_DIA_DESCRIPTION: "ERRORS_DIA_DESCRIPTION",
  ERRORS_SELF_DESCRIPTION: "ERRORS_SELF_DESCRIPTION",

  SETTINGS_PIR_DESCRIPTION: "SETTINGS_PIR_DESCRIPTION",
  SETTINGS_PIA_DESCRIPTION: "SETTINGS_PIA_DESCRIPTION",
  SETTINGS_MSG_DESCRIPTION: "SETTINGS_MSG_DESCRIPTION",
  SETTINGS_DIA_DESCRIPTION: "SETTINGS_DIA_DESCRIPTION",
  SETTINGS_SELF_DESCRIPTION: "SETTINGS_SELF_DESCRIPTION",

  POSITION_PLACEHOLDER: "POSITION_PLACEHOLDER",
  SELECT_PLACEHOLDER: "SELECT_PLACEHOLDER",
  SELECT_PLACEHOLDER_2: "SELECT_PLACEHOLDER_2",
  TEXT_EDITOR_PLACEHOLDER: "TEXT_EDITOR_PLACEHOLDER",

  EXPLICIT_ATTRIBUTES_SECTION_TITLE: "EXPLICIT_ATTRIBUTES_SECTION_TITLE",
  CONTENT_SECTION_TITLE: "CONTENT_SECTION_TITLE",
  TEXT_SECTION_TITLE: "TEXT_SECTION_TITLE",

  MISSING_FIELDS: "MISSING_FIELDS",
  MISSING_FIELDS_MESSAGE: "MISSING_FIELDS_MESSAGE",

  ADD_LANGUAGE_BTN: "ADD_LANGUAGE_BTN",
  LANGUAGE_LABEL: "LANGUAGE_LABEL",

  DELETE_LANGUAGE_MODAL_TITLE: "DELETE_LANGUAGE_MODAL_TITLE",
  DELETE_LANGUAGE_MODAL_TEXT_1: "DELETE_LANGUAGE_MODAL_TEXT_1",
  DELETE_LANGUAGE_MODAL_TEXT_2: "DELETE_LANGUAGE_MODAL_TEXT_2",

  BACK_BTN: "BACK_BTN",
  SAVE_BTN: "SAVE_BTN",
  SHOW_DASHBOARD: "SHOW_DASHBOARD",

  UNKNOWN: "UNKNOWN",

  NO_LOCATION: "NO_LOCATION",

  EDIT: "EDIT",
  VIEW_DETAILS: "VIEW_DETAILS",
  ADD_NEW_ELEMENT_LABEL: "ADD_NEW_ELEMENT_LABEL",

  COUNTRY_TITLE: "COUNTRY_TITLE",
  ACTIVE_USERS: "ACTIVE_USERS",
  ACTIVE_APPS: "ACTIVE_APPS",

  MARKETS_NAV_BTN: "MARKETS_NAV_BTN",

  SEARCH_MARKETS_PLACEHOLDER: "SEARCH_MARKETS_PLACEHOLDER",
  ADD_MARKET_TITLE: "ADD_MARKET_TITLE",
  MARKET_CODE: "MARKET_CODE",
  MARKET_NAME: "MARKET_NAME",
  EDIT_MARKET: "EDIT_MARKET",
  NEW_MARKET: "NEW_MARKET",
  NEW_MARKET_ADDED_DESCRIPTION: "NEW_MARKET_ADDED_DESCRIPTION",
  CREATE_MARKET_ERROR: "CREATE_MARKET_ERROR",
  UPDATE_MARKET_SUCCESS: "UPDATE_MARKET_SUCCESS",
  UPDATE_MARKET_SUCCESS_INFO: "UPDATE_MARKET_SUCCESS_INFO",
  UPDATE_MARKET_ERROR: "UPDATE_MARKET_ERROR",

  CODE_PLACEHOLDER: "CODE_PLACEHOLDER",
  SUCCESSFULLY_CREATED: "SUCCESSFULLY_CREATED",

  REMOVE_BTN: "REMOVE_BTN",

  REMOVE_MARKET_QUESTION: "REMOVE_MARKET_QUESTION",
  REMOVE_MARKET_INFO: "REMOVE_MARKET_INFO",

  DELETE_MARKET_SUCCESS: "DELETE_MARKET_SUCCESS",
  DELETE_MARKET_SUCCESS_INFO: "DELETE_MARKET_SUCCESS_INFO",
  DELETE_MARKET_ERROR: "DELETE_MARKET_ERROR",

  FETCH_MARKETS_ERROR: "FETCH_MARKETS_ERROR",

  // Apps Management Page
  GENERAL_TITLE: "GENERAL_TITLE",
  LOCALISATIONS_TITLE: "LOCALISATIONS_TITLE",
  LOCALISATION_TITLE: "LOCALISATION_TITLE",
  DASHBOARDS_TITLE: "DASHBOARDS_TITLE",
  CUSTOMIZE_EMAIL_TITLE: "CUSTOMIZE_EMAIL_TITLE",
  FETCH_APPS_ERROR: "FETCH_APPS_ERROR",
  FETCH_APPS_MARKETS_ERROR: "FETCH_APPS_MARKETS_ERROR",
  SEARCH_APPS_PLACEHOLDER: "SEARCH_APPS_PLACEHOLDER",

  FROM_EXISTING_APP_TITLE: "FROM_EXISTING_APP_TITLE",
  FROM_SCRATCH_TITLE: "FROM_SCRATCH_TITLE",

  APP_NAME_TITLE: "APP_NAME_TITLE",
  OPEN_APP_TITLE: "OPEN_APP_TITLE",

  NEXT_BTN: "NEXT_BTN",
  FINISH_BTN: "FINISH_BTN",

  SAVE_AND_CONTINUE_BUTTON_TITLE: "SAVE_AND_CONTINUE_BUTTON_TITLE",
  SAVE_AND_FINISH_BUTTON_TITLE: "SAVE_AND_FINISH_BUTTON_TITLE",
  BASIC_INFO_TITLE_SHORT: "BASIC_INFO_TITLE",

  NO_MARKETS_ELEMENTS_DATA: "NO_MARKETS_ELEMENTS_DATA",
  CHOOSE_MARKET_FROM_LIST: "CHOOSE_MARKET_FROM_LIST",

  APP_MARKETS_CREATED_TITLE: "APP_MARKETS_CREATED_TITLE",
  APP_MARKETS_CREATED_DESCRIPTION: "APP_MARKETS_CREATED_DESCRIPTION",
  APP_MARKETS_DELETED_TITLE: "APP_MARKETS_DELETED_TITLE",
  APP_MARKETS_DELETED_DESCRIPTION: "APP_MARKETS_DELETED_DESCRIPTION",

  OK_TITLE: "OK_TITLE",

  REFRESH_TOKEN_EXPIRED_TITLE: "REFRESH_TOKEN_EXPIRED_TITLE",
  REFRESH_TOKEN_EXPIRED_MSG: "REFRESH_TOKEN_EXPIRED_MSG",

  APP_UPDATED_SHORT_TITLTE: "APP_UPDATED_SHORT_TITLTE",
  APP_CREATED_SHORT_TITLTE: "APP_CREATED_SHORT_TITLTE",
  APP_UPDATED_LONG_TITLTE: "APP_UPDATED_LONG_TITLTE",
  APP_CREATED_LONG_TITLTE: "APP_CREATED_LONG_TITLTE",
  APP_UPDATE_ERROR_TITLE: "APP_UPDATE_ERROR_TITLE",
  APP_CREATE_ERROR_TITLE: "APP_CREATE_ERROR_TITLE",
  APP_FEATURE_UPDATE_ERROR_TITLE: "APP_FEATURE_UPDATE_ERROR_TITLE",
  APP_MARKETS_CREATE_ERROR_TITLE: "APP_MARKETS_CREATE_ERROR_TITLE",
  APP_MARKETS_DELETE_ERROR_TITLE: "APP_MARKETS_DELETE_ERROR_TITLE",
  APPLICATION_NAME_TITLE: "APPLICATION_NAME_TITLE",
  LINK_TO_APP_TITLE: "LINK_TO_APP_TITLE",
  LINK_TO_APP_PLACEHOLDER: "LINK_TO_APP_PLACEHOLDER",
  NEW_APP_TITLE: "NEW_APP_TITLE",

  SELECT_ALL_TITLE: "SELECT_ALL_TITLE",
  DESELECT_ALL_TITLE: "DESELECT_ALL_TITLE",
  REMOVE_ROLE_TITLE: "REMOVE_ROLE_TITLE",
  REMOVE_ROLE_WARNING_TITLE: "REMOVE_ROLE_WARNING_TITLE",
  EDIT_ROLE_NAME: "EDIT_ROLE_NAME",
  NEW_ROLE_TITLE: "NEW_ROLE_TITLE",
  ROLE_NAME_TITLE: "ROLE_NAME_TITLE",
  ROLES_NAME_TITLE: "ROLES_NAME_TITLE",
  MANAGE_ROLE_FEATURE_TITLE: "MANAGE_ROLE_FEATURE_TITLE",
  FEATURES_TITLE: "FEATURES_TITLE",
  ERROR_FETCHING_GROUP_DATA_MESSAGE: "ERROR_FETCHING_GROUP_DATA_MESSAGE",
  NO_ROLES_MESSAGE: "NO_ROLES_MESSAGE",
  GET_APP_GROUP_ERROR: "GET_APP_GROUP_ERROR",

  APP_ROLE_CREATE_TITLE_SHORT: "APP_ROLE_CREATE_TITLE_SHORT",
  APP_ROLE_CREATE_TITLE_LONG: "APP_ROLE_CREATE_TITLE_LONG",
  APP_ROLE_CREATE_ERROR_TITLE: "APP_ROLE_CREATE_ERROR_TITLE",
  APP_ROLE_UPDATE_TITLE_ERROR: "APP_ROLE_UPDATE_TITLE_ERROR",

  APP_ROLE_DELETE_TITLE_SHORT: "APP_ROLE_DELETE_TITLE_SHORT",
  APP_ROLE_DELETE_TITLE_LONG: "APP_ROLE_DELETE_TITLE_LONG",
  APP_ROLE_DELETE_TITLE_ERROR: "APP_ROLE_DELETE_TITLE_ERROR",

  EMAIL_TEMPLATE_HINT: "EMAIL_TEMPLATE_HINT",
  EMAIL_TEMPLATE_GREETINGS: "EMAIL_TEMPLATE_GREETINGS",
  EMAIL_TEMPLATE_DETAILS: "EMAIL_TEMPLATE_DETAILS",

  ENTER_ADDITIONAL_TEXT_PLACEHOLDER: "Enter additional text",

  SELECT_LANGUAGE_PLACEHOLDER: "SELECT_LANGUAGE_PLACEHOLDER",
  NO_CHOSEN_FILE: "NO_CHOSEN_FILE",
  TRANSLATION_FILE: "TRANSLATION_FILE",
  DEFAULT_QUESTION: "DEFAULT_QUESTION",
  UPLOAD: "UPLOAD",
  MISSING_KEYS_COUNT: "MISSING_KEYS_COUNT",
  DOWNLOAD_FILE_TOOLTIP: "DOWNLOAD_FILE_TOOLTIP",

  LOCALIZATION_UPLOAD_ERROR_TITLE: "LOCALIZATION_UPLOAD_ERROR_TITLE",
  LOCALIZATION_DELETE_TITLE: "LOCALIZATION_DELETE_TITLE",
  LOCALIZATION_DELETE_ERROR: "LOCALIZATION_DELETE_ERROR",
  LOCALIZATION_ADDED_TITLE: "LOCALIZATION_ADDED_TITLE",
  DEFAULT_LANGUAGE_WARNING: "DEFAULT_LANGUAGE_WARNING",

  NO_TRANSLATION_YET: "NO_TRANSLATION_YET",
  UPLOADING_SUMMARY: "UPLOADING_SUMMARY",
  SOME_KEYS_ARE_MISSING: "SOME_KEYS_ARE_MISSING",
  SOME_KEYS_ARE_MISSING_INFO: "SOME_KEYS_ARE_MISSING_INFO",

  MISSING_KEY_TITLE: "MISSING_KEY_TITLE",
  DEFAULT_LOCALIZATION_TITLE: "DEFAULT_LOCALIZATION_TITLE",
  CANCEL_UPLOAD_BTN: "CANCEL_UPLOAD_BTN",
  CLOSE_BTN: "CLOSE_BTN",

  CONFIGURATION_TITLE: "CONFIGURATION_TITLE",
  CONFIGURATION_SWITCH_ON_HINT: "CONFIGURATION_SWITCH_ON_HINT",
  CONFIGURATION_SETTINGS_HINT: "CONFIGURATION_SETTINGS_HINT",
  DOWNLOAD_JSON_TITLE: "DOWNLOAD_JSON_TITLE",
  CONFIGURE_FEATURES_TITLE: "CONFIGURE_FEATURES_TITLE",
  FEATURE_TITLE: "FEATURE_TITLE",
  FEATURE_PlACEHOLDER: "FEATURE_PlACEHOLDER",
  NO_FEATURES_YET: "NO_FEATURES_YET",
  NO_FIRMWARES_YET: "NO_FIRMWARES_YET",

  SETTING_NAME_ERROR_TITLE: "SETTING_NAME_ERROR_TITLE",
  ADD_FEATURE_TITLE: "ADD_FEATURE_TITLE",
  ADD_FIRMWARE_TITLE: "ADD_FIRMWARE_TITLE",

  CONFIGURATION_SAVED_TITLE: "CONFIGURATION_SAVED_TITLE",
  CONFIGURATION_DISABLED_TITLE: "CONFIGURATION_DISABLED_TITLE",
  CONFIGURATION_SAVE_ERROR_TITLE: "CONFIGURATION_SAVE_ERROR_TITLE",
  CONFIGURATION_SAVED_DESCRIPTION: "CONFIGURATION_SAVED_DESCRIPTION",
  MARKET_CONFIGURATION_SAVED_DESCRIPTION: "MARKET_CONFIGURATION_SAVED_DESCRIPTION",

  START_ADDING_FEATURES_TITLE: "START_ADDING_FEATURES_TITLE",
  START_ADDING_DASHBOARDS_OPTIONS_TITLE: "START_ADDING_DASHBOARDS_OPTIONS_TITLE",

  FEATURES_DEACTIVATING_TITLE: "FEATURES_DEACTIVATING_TITLE",
  FEATURES_DEACTIVATING_DESCRIPTION: "FEATURES_DEACTIVATING_DESCRIPTION",
  DISABLE_BTN: "DISABLE_BTN",

  RESET_TO_DEFAULT_SETTINGS: "RESET_TO_DEFAULT_SETTINGS",

  APPLICATION_FROM_EXISTING: "APPLICATION_FROM_EXISTING",

  CONSENTS_ARE_NOT_CONFIGURED_TITLE: "CONSENTS_ARE_NOT_CONFIGURED_TITLE",

  DASHBOARD_SETTINGS_TITLE: "DASHBOARD_SETTINGS_TITLE",
  DASHBOARD_SETTINGS_DESCRIPTION: "DASHBOARD_SETTINGS_DESCRIPTION",

  CHANGES_NOT_SAVED_TITLE: "CHANGES_NOT_SAVED_TITLE",
  CHANGES_NOT_SAVED_INFO: "CHANGES_NOT_SAVED_INFO",
  CHANGES_NOT_SAVED_LEAVE_OPTION: "CHANGES_NOT_SAVED_LEAVE_OPTION",
  CHANGES_NOT_SAVED_SAVE_DRAFT_OPTION: "CHANGES_NOT_SAVED_SAVE_DRAFT_OPTION",
  CHANGES_NOT_SAVED_ACTIVATE_OPTION: "CHANGES_NOT_SAVED_ACTIVATE_OPTION",
  CHANGES_NOT_SAVED_CONTINUE_OPTION: "CHANGES_NOT_SAVED_CONTINUE_OPTION",
  CHANGES_NOT_SAVED_WARNING: "CHANGES_NOT_SAVED_WARNING",

  SAVE_DRAFT_TITLE: "SAVE_DRAFT_TITLE",
  ACTIVATE_TITLE: "ACTIVATE_TITLE",
  DISCARD_CHANGES_TITLE: "DISCARD_CHANGES_TITLE",

  UNDO_CHANGES_BTN: "UNDO_CHANGES_BTN",

  // Notification Management Page
  NOTIFICATION_CENTER_TITLE: "NOTIFICATION_CENTER_TITLE",

  FETCH_NOTIFICATIONS_ERROR: "FETCH_NOTIFICATIONS_ERROR",

  NOTIFICATIONS_FETCH_ERROR: "NOTIFICATIONS_FETCH_ERROR",
  NOTIFICATION_FETCH_ERROR: "NOTIFICATION_FETCH_ERROR",

  SEARCH_PLACEHOLDER: "SEARCH_PLACEHOLDER",
  NEW_NOTIFICATION_TOOLTIP_LABEL: "NEW_NOTIFICATION_TOOLTIP_LABEL",

  NO_NOTIFICATION_FOUND: "NO_NOTIFICATION_FOUND",
  CHECK_NOTIFICATION_MESSAGE: "CHECK_NOTIFICATION_MESSAGE",

  NO_NOTIFICATION_CAMPAIGNS_FOUND: "NO_NOTIFICATION_CAMPAIGNS_FOUND",
  CHECK_NOTIFICATION_CAMPAIGNS_MESSAGE: "CHECK_NOTIFICATION_CAMPAIGNS_MESSAGE",

  LOCALIZATION_TITLE: "LOCALIZATION_TITLE",

  CREATE_NOTIFICATION_TITLE: "CREATE_NOTIFICATION_TITLE",
  EDIT_NOTIFICATION_TITLE: "EDIT_NOTIFICATION_TITLE",

  DESTINATION_TITLE: "DESTINATION_TITLE",
  DESTINATION_PLACEHOLDER: "DESTINATION_PLACEHOLDER",
  IMAGE_TITLE: "IMAGE_TITLE",
  TITLE: "TITLE",
  TITLE_PLACEHOLDER: "TITLE_PLACEHOLDER",
  BODY_TITLE: "BODY_TITLE",
  BODY_PLACEHOLDER: "BODY_PLACEHOLDER",

  PAUSE_MODE_DESTINATION_OPTION: "PAUSE_MODE_DESTINATION_OPTION",
  FLEX_PUFF_DESTINATION_OPTION: "FLEX_PUFF_DESTINATION_OPTION",
  FLEX_BATTERY_DESTINATION_OPTION: "FLEX_BATTERY_DESTINATION_OPTION",
  SOFTWATRE_UPDATE_DESTINATION_OPTION: "SOFTWATRE_UPDATE_DESTINATION_OPTION",
  LOW_PERFORMANCE_DESTINATION_OPTION: "LOW_PERFORMANCE_DESTINATION_OPTION",
  PERSONALIZED_CHARGING_DESTINATION_OPTION: "PERSONALIZED_CHARGING_DESTINATION_OPTION",
  LOYALTY_DESTINATION_OPTION: "LOYALTY_DESTINATION_OPTION",
  USAGE_DESTINATION_OPTION: "USAGE_DESTINATION_OPTION",
  HOME_DESTINATION_OPTION: "HOME_DESTINATION_OPTION",
  EXPERIENCE_COACH_DESTINATION_OPTION: "EXPERIENCE_COACH_DESTINATION_OPTION",
  LOYALTY_BADGES_DESTINATION_OPTION: "LOYALTY_BADGES_DESTINATION_OPTION",
  NOTIFICATIONS_DESTINATION_OPTION: "NOTIFICATIONS_DESTINATION_OPTION",

  NO_LANGUAGES_TEXT: "NO_LANGUAGES_TEXT",
  ADD_LANGUAGES_TEXT: "ADD_LANGUAGES_TEXT",

  DRAG_AND_DROP_FILE_INFO: "DRAG_AND_DROP_FILE_INFO",
  UPLOADING_FILE_SIZE_INFO: "UPLOADING_FILE_SIZE_INFO",
  UPLOADED_FILE_SIZE_INFO: "UPLOADED_FILE_SIZE_INFO",
  UPLOADED: "UPLOADED",

  CREATE_NOTIFICATION_ERROR: "CREATE_NOTIFICATION_ERROR",
  CREATE_NOTIFICATION_SUCCESS: "CREATE_NOTIFICATION_SUCCESS",
  CREATE_NOTIFICATION_SUCCESS_INFO: "CREATE_NOTIFICATION_SUCCESS_INFO",

  UPDATE_NOTIFICATION_ERROR: "UPDATE_NOTIFICATION_ERROR",
  UPDATE_NOTIFICATION_SUCCESS: "UPDATE_NOTIFICATION_SUCCESS",
  UPDATE_NOTIFICATION_SUCCESS_INFO: "UPDATE_NOTIFICATION_SUCCESS_INFO",

  NOTIFICATION_IMAGE_UPLOAD_SUCCESS: "NOTIFICATION_IMAGE_UPLOAD_SUCCESS",
  NOTIFICATION_IMAGE_UPLOAD_ERROR: "NOTIFICATION_IMAGE_UPLOAD_ERROR",

  INVALID_NOTIFICATION_NAME_ERROR: "INVALID_NOTIFICATION_NAME_ERROR",
  INVALID_PARAMETER_PROVIDED_ERROR: "INVALID_PARAMETER_PROVIDED_ERROR",
  NOTIFICATION_NAME_ALREADY_EXISTS_ERROR: "NOTIFICATION_NAME_ALREADY_EXISTS_ERROR",
  NOTIFICATION_NOT_FOUND_ERROR: "NOTIFICATION_NOT_FOUND_ERROR",
  INVALID_ADMIN_GROUP_ERROR: "INVALID_ADMIN_GROUP_ERROR",

  // Fleet Management Page

  // Campaigns
  CAMPAIGNS_TITLE: "CAMPAIGNS_TITLE",
  FIRMARE_UPDATE_TITLE: "FIRMARE_UPDATE_TITLE",
  NOTIFICATION_TITLE: "NOTIFICATION_TITLE",

  FWU_CAMPAIGNS_FETCH_ERROR: "FWU_CAMPAIGNS_FETCH_ERROR",
  NOTIFICATION_CAMPAIGNS_FETCH_ERROR: "NOTIFICATION_CAMPAIGNS_FETCH_ERROR",

  CAMPAIGN_NAME_TITLE: "CAMPAIGN_NAME_TITLE",
  CAMPAIGN_NAME_WARNING: "CAMPAIGN_NAME_WARNING",
  NEW_FW_VERSION_TITLE: "NEW_FW_VERSION_TITLE",
  START_DATE_TITLE: "START_DATE_TITLE",
  PROGRESS_TITLE: "PROGRESS_TITLE",
  AUDIENCE_TITLE: "AUDIENCE_TITLE",
  CATEGORY_TITLE: "CATEGORY_TITLE",

  FWU_UPDATED_INFO: "FWU_UPDATED_INFO",
  FWU_DEACTIVATED_INFO: "FWU_DEACTIVATED_INFO",

  NOTIFICATION_OPENED_INFO: "NOTIFICATION_OPENED_INFO",
  DEACTIVATED_INFO: "DEACTIVATED_INFO",

  BIN_FILE_TITLE: "BIN_FILE_TITLE",
  SIGNATURE_FILE_TITLE: "SIGNATURE_FILE_TITLE",

  MAJOR_TITLE: "MAJOR_TITLE",
  MINOR_TITLE: "MINOR_TITLE",
  PATCH_TITLE: "PATCH_TITLE",

  DEVICE_MODEL: "DEVICE_MODEL",
  DEVICE_TYPE: "DEVICE_TYPE",

  NO_FILE_CHOSEN: "NO_FILE_CHOSEN",

  REMOVE_FIRMWARE_QUESTION: "REMOVE_FIRMWARE_QUESTION",
  REMOVE_FIRMWARE_INFO: "REMOVE_FIRMWARE_INFO",

  FETCH_FWU_CAMPAIGNS_ERROR: "FETCH_FWU_CAMPAIGNS_ERROR",
  FETCH_FWU_CAMPAIGN_DETAILS_ERROR: "FETCH_FWU_CAMPAIGN_DETAILS_ERROR",
  FETCH_NOTIFICATION_CAMPAIGNS_ERROR: "FETCH_NOTIFICATION_CAMPAIGNS_ERROR",
  BODY: "BODY",

  DISCARD_CAMPAIGN_MODAL_TITLE: "DISCARD_CAMPAIGN_MODAL_TITLE",
  DISCARD_CAMPAIGN_EDITING_MODAL_TITLE: "DISCARD_CAMPAIGN_EDITING_MODAL_TITLE",
  DISCARD_CAMPAIGN_MODAL_TEXT: "DISCARD_CAMPAIGN_MODAL_TEXT",
  DISCARD_CAMPAIGN_MODAL_EDIT_TEXT: "DISCARD_CAMPAIGN_MODAL_EDIT_TEXT",
  DISCARD_NOTIFICATION_CAMPAIGN_MODAL_TITLE: "DISCARD_NOTIFICATION_CAMPAIGN_MODAL_TITLE",
  DISCARD_NOTIFICATION_CAMPAIGN_MODAL_TEXT: "DISCARD_NOTIFICATION_CAMPAIGN_MODAL_TEXT",
  DISCARD_NOTIFICATION_CAMPAIGN_MODAL_EDIT_TEXT: "DISCARD_NOTIFICATION_CAMPAIGN_MODAL_EDIT_TEXT",

  NEW_FWU_CAMPAIGN_TITLE: "NEW_FWU_CAMPAIGN_TITLE",

  FIRMWARE_TITLE: "FIRMWARE_TITLE",
  PREVIOUS_BTN: "PREVIOUS_BTN",
  TIME_INPUT_PLACEHOLER: "TIME_INPUT_PLACEHOLER",

  NOTIFICATION_MESSAGE_TITLE: "NOTIFICATION_MESSAGE_TITLE",
  START_TIME_TITLE: "START_TIME_TITLE",
  PUSH_NOTIFICATION_DATE_TITLE: "PUSH_NOTIFICATION_DATE_TITLE",
  PUSH_NOTIFICATION_TIME_TITLE: "PUSH_NOTIFICATION_TIME_TITLE",

  PUSH_NOTIFICATION_CHECKBOX_LABEL: "PUSH_NOTIFICATION_CHECKBOX_LABEL",

  NOTIFICATION_CAMPAIGN_NOTE: "NOTIFICATION_CAMPAIGN_NOTE",
  NOTIFICATION_CAMPAIGN_UPDATE_NOTE: "NOTIFICATION_CAMPAIGN_UPDATE_NOTE",
  PUSH_NOTIFICATION_INFO: "PUSH_NOTIFICATION_INFO",

  DEVICE_MODEL_TITLE: "DEVICE_MODEL_TITLE",
  DEVICE_TYPE_TITLE: "DEVICE_TYPE_TITLE",

  DEVICE_MODEL_PLACEHOLER: "DEVICE_MODEL_PLACEHOLER",
  DEVICE_TYPE_PLACEHOLER: "DEVICE_TYPE_PLACEHOLER",

  LIST_OF_DEVICES_TITLE: "LIST_OF_DEVICES_TITLE",

  CURRENT_FW_VERSION_TITLE: "CURRENT_FW_VERSION_TITLE",
  OPTIONAL_INFO: "OPTIONAL_INFO",

  NOTIFICATION_CAMPAIGN_TITLE: "NOTIFICATION_CAMPAIGN_TITLE",
  CAMPAIGN_SETUP_TITLE: "CAMPAIGN_SETUP_TITLE",
  ADD_BTN: "ADD_BTN",

  LIST_OF_DEVICES_FILE_TITLE: "LIST_OF_DEVICES_FILE_TITLE",
  INCOMPATIBLE_DEVICES_INFO: "INCOMPATIBLE_DEVICES_INFO",
  INCOMPATIBLE_DEVICE_INFO: "INCOMPATIBLE_DEVICE_INFO",
  DONWLOAD_LIST_BTN: "DONWLOAD_LIST_BTN",
  NO_BTN: "NO_BTN",
  YES_BTN: "YES_BTN",

  LIST_OF_DEVICES_INFO: "LIST_OF_DEVICES_INFO",

  SELECT_FW_VERSION_TITLE: "SELECT_FW_VERSION_TITLE",
  ADD_FIRMWARE_BTN: "ADD_FIRMWARE_BTN",

  SELECT_MESSAGE_PLACEHOLDER: "SELECT_MESSAGE_PLACEHOLDER",

  INFORMATIVE_CATEGORY_TITLE: "INFORMATIVE_CATEGORY_TITLE",
  MARKETING_CATEGORY_TITLE: "MARKETING_CATEGORY_TITLE",
  CONVERSION_CATEGORY_TITLE: "CONVERSION_CATEGORY_TITLE",
  SYSTEM_CATEGORY_TITLE: "SYSTEM_CATEGORY_TITLE",

  APP_USERS_TITLE: "APP_USERS_TITLE",
  DEVICE_TYPE_USERS_TITLE: "DEVICE_TYPE_USERS_TITLE",

  SELECT_DEVICES_TITLE: "SELECT_DEVICES_TITLE",

  DEVICE_SERIAL_NUMBER_TITLE: "DEVICE_SERIAL_NUMBER_TITLE",
  SERIAL_NUMBERS_TITLE: "SERIAL_NUMBERS_TITLE",
  USERS_TITLE: "USERS_TITLE",

  FETCH_FWU_VERSIONS_ERROR: "FETCH_FWU_VERSIONS_ERROR",

  CREATE_CAMPAIGN_SUCCESS: "CREATE_CAMPAIGN_SUCCESS",
  CREATE_CAMPAIGN_SUCCESS_INFO: "CREATE_CAMPAIGN_SUCCESS_INFO",

  CREATE_FWU_CAMPAIGN_ERROR: "CREATE_FWU_CAMPAIGN_ERROR",

  CREATE_FW_NOTIFICATION_CAMPAIGN_SUCCESS: "CREATE_FW_NOTIFICATION_CAMPAIGN_SUCCESS",
  CREATE_FW_NOTIFICATION_CAMPAIGN_SUCCESS_INFO: "CREATE_FW_NOTIFICATION_CAMPAIGN_SUCCESS_INFO",
  CREATE_FW_NOTIFICATION_CAMPAIGN_ERROR: "CREATE_FW_NOTIFICATION_CAMPAIGN_ERROR",

  DELETE_FWU_VERSION_ERROR: "DELETE_FWU_VERSION_ERROR",
  DELETE_FWU_VERSION_SUCCESS: "DELETE_FWU_VERSION_SUCCESS",
  DELETE_FWU_VERSION_SUCCESS_INFO: "DELETE_FWU_VERSION_SUCCESS_INFO",

  INVALID_BIN_FILE_TITLE: "INVALID_BIN_FILE_TITLE",
  INVALID_BIN_FILE_DESCRIPTION: "INVALID_BIN_FILE_DESCRIPTION",

  INVALID_SIGNATURE_FILE_TITLE: "INVALID_SIGNATURE_FILE_TITLE",
  INVALID_SIGNATURE_FILE_DESCRIPTION: "INVALID_SIGNATURE_FILE_DESCRIPTION",

  CREATE_FWU_VERSION_ERROR: "CREATE_FWU_VERSION_ERROR",
  UPDATE_FWU_VERSION_ERROR: "UPDATE_FWU_VERSION_ERROR",
  UPLOAD_FWU_FILE_ERROR: "UPLOAD_FWU_FILE_ERROR",
  CREATE_FWU_VERSION_SUCCESS: "CREATE_FWU_VERSION_SUCCESS",
  CREATE_FWU_VERSION_SUCCESS_INFO: "CREATE_FWU_VERSION_SUCCESS_INFO",
  UPDATE_FWU_VERSION_SUCCESS: "UPDATE_FWU_VERSION_SUCCESS",
  UPDATE_FWU_VERSION_SUCCESS_INFO: "UPDATE_FWU_VERSION_SUCCESS_INFO",

  NO_FILE_UPLOADED: "NO_FILE_UPLOADED",

  UPDATE_PACKAGE_NOT_FOUND: "UPDATE_PACKAGE_NOT_FOUND",
  SIGNATURE_FILE_IS_INVALID_BASE64_CONTENT: "SIGNATURE_FILE_IS_INVALID_BASE64_CONTENT",
  OTA_UPDATE_ALREADY_EXISTS: "OTA_UPDATE_ALREADY_EXISTS",
  CORRECT_DUSNS_NOT_FOUND: "CORRECT_DUSNS_NOT_FOUND",
  INVALID_PARAMETER_PROVIDED: "INVALID_PARAMETER_PROVIDED",
  CAMPAIGN_NAME_ALREADY_EXISTS: "CAMPAIGN_NAME_ALREADY_EXISTS",
  HTTP_METHOD_IS_NOT_SUPPORTED: "HTTP_METHOD_IS_NOT_SUPPORTED",
  INVALID_ADMIN_GROUP: "INVALID_ADMIN_GROUP",
  REQUEST_QUERY_IS_NOT_PROVIDED: "REQUEST_QUERY_IS_NOT_PROVIDED",
  INVALID_DUSNS_AND_USER_IDS_PROVIDED: "INVALID_DUSNS_AND_USER_IDS_PROVIDED",
  NOTIFICATION_CAMPAIGN_NOT_FOUND: "NOTIFICATION_CAMPAIGN_NOT_FOUND",
  NOTIFICATION_CAMPAIGN_ALREADY_DEACTIVATED: "NOTIFICATION_CAMPAIGN_ALREADY_DEACTIVATED",
  NOTIFICATION_CAMPAIGN_ALREADY_STARTED: "NOTIFICATION_CAMPAIGN_ALREADY_STARTED",
  NOTIFICATION_MESSAGE_NOT_FOUND: "NOTIFICATION_MESSAGE_NOT_FOUND",
  INVALID_DETAILS_PROVIDED: "INVALID_DETAILS_PROVIDED",

  INCORRECT_DEVICES_TITLE: "INCORRECT_DEVICES_TITLE",
  INCORRECT_DEVICE_DESCRIPTION: "INCORRECT_DEVICE_DESCRIPTION",
  INCORRECT_DEVICES_DESCRIPTION: "INCORRECT_DEVICES_DESCRIPTION",

  DEVICE_INFO_TITLE: "DEVICE_INFO_TITLE",
  NEW_FIRMWARE_VERSION_TITLE: "NEW_FIRMWARE_VERSION_TITLE",

  DEACTIVATE_BTN: "DEACTIVATE_BTN",

  CAMPAIGN_SETTINGS_TITLE: "CAMPAIGN_SETTINGS_TITLE",
  FWU_CAMPAIGN_SETTINGS_NOTE: "FWU_CAMPAIGN_SETTINGS_NOTE",
  NOTIFICATION_CAMPAIGN_SETTINGS_NOTE_APPS: "NOTIFICATION_CAMPAIGN_SETTINGS_NOTE_APPS",
  NOTIFICATION_CAMPAIGN_SETTINGS_NOTE_DEVICES: "NOTIFICATION_CAMPAIGN_SETTINGS_NOTE_DEVICES",
  APPLY_CHANGES_BTN: "APPLY_CHANGES_BTN",

  APPLYING_CHANGES_INFO: "APPLYING_CHANGES_INFO",

  UPDATE_FWU_CAMPAIGN_SUCCESS: "UPDATE_FWU_CAMPAIGN_SUCCESS",
  UPDATE_FWU_CAMPAIGN_SUCCESS_INFO: "UPDATE_FWU_CAMPAIGN_SUCCESS_INFO",
  UPDATE_FWU_CAMPAIGN_ERROR: "UPDATE_FWU_CAMPAIGN_ERROR",

  UPDATE_NOTIFICATION_CAMPAIGN_SUCCESS: "UPDATE_NOTIFICATION_CAMPAIGN_SUCCESS",
  UPDATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO: "UPDATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO",
  UPDATE_NOTIFICATION_CAMPAIGN_ERROR: "UPDATE_NOTIFICATION_CAMPAIGN_ERROR",

  DEACTIVATE_FWU_CAMPAIGN_SUCCESS: "DEACTIVATE_FWU_CAMPAIGN_SUCCESS",
  DEACTIVATE_FWU_CAMPAIGN_SUCCESS_INFO: "DEACTIVATE_FWU_CAMPAIGN_SUCCESS_INFO",
  DEACTIVATE_FWU_CAMPAIGN_ERROR: "DEACTIVATE_FWU_CAMPAIGN_ERROR",

  DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS: "DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS",
  DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO: "DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO",
  DEACTIVATE_NOTIFICATION_CAMPAIGN_ERROR: "DEACTIVATE_NOTIFICATION_CAMPAIGN_ERROR",

  DOWNLOAD_REPORT_BTN: "DOWNLOAD_REPORT_BTN",

  CANCELED_LABEL: "CANCELED_LABEL",
  REMOVED_LABEL: "REMOVED_LABEL",
  REJECTED_LABEL: "REJECTED_LABEL",
  QUEUED_LABEL: "QUEUED_LABEL",
  UPDATED_LABEL: "UPDATED_LABEL",
  IN_PROGRESS_LABEL: "IN_PROGRESS_LABEL",
  TIMED_OUT_LABEL: "TIMED_OUT_LABEL",
  NEVER_ATTEMPTED_LABEL: "NEVER_ATTEMPTED_LABEL",
  RECEIVED_LABEL: "RECEIVED_LABEL",
  WAITING_RESPONSE_LABEL: "WAITING_RESPONSE_LABEL",

  CANCELED_LABEL_INFO: "CANCELED_LABEL_INFO",
  REMOVED_LABEL_INFO: "REMOVED_LABEL_INFO",
  FAILED_LABEL_INFO: "FAILED_LABEL_INFO",
  REJECTED_LABEL_INFO: "REJECTED_LABEL_INFO",
  QUEUED_LABEL_INFO: "QUEUED_LABEL_INFO",
  UPDATED_LABEL_INFO: "UPDATED_LABEL_INFO",
  IN_PROGRESS_LABEL_INFO: "IN_PROGRESS_LABEL_INFO",
  NEVER_ATTEMPTED_LABEL_INFO: "NEVER_ATTEMPTED_LABEL_INFO",

  CREATE_NOTIFICATION_CAMPAIGN_ERROR: "CREATE_NOTIFICATION_CAMPAIGN_ERROR",
  CREATE_NOTIFICATION_CAMPAIGN_SUCCESS: "CREATE_NOTIFICATION_CAMPAIGN_SUCCESS",
  CREATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO: "CREATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO",

  SCHEDULED_TITLE: "SCHEDULED_TITLE",

  MESSAGES: "MESSAGES",
  SYSTEM_MESSAGES: "SYSTEM_MESSAGES",

  DEACTIVATE_CAMPAIGN_TITLE: "DEACTIVATE_CAMPAIGN_TITLE",
  DEACTIVATE_CAMPAIGN_TEXT: "DEACTIVATE_CAMPAIGN_TEXT",
  YES_DEACTIVATE_BTN: "YES_DEACTIVATE_BTN",

  FETCHING_DATA_TITLE: "FETCHING_DATA_TITLE",
  FETCHING_DATA_FAILED_TITLE: "FETCHING_DATA_FAILED_TITLE",
  RETRY_BTN: "RETRY_BTN",
  DETAILS_BTN: "DETAILS_BTN",
  HIDE_DETAILS_BTN: "HIDE_DETAILS_BTN",

  COPIED_TITLE: "COPIED_TITLE",

  CURRENT_FW_VERSION_HINT: "CURRENT_FW_VERSION_HINT",
  MESSAGE_PREVIEW_TITLE: "MESSAGE_PREVIEW_TITLE",

  SET_AUDIENCE_TITLE: "SET_AUDIENCE_TITLE",

  DEVICES_TITLE: "DEVICES_TITLE",
  FIRMWARE_CAMPAIGNS_TITLE: "FIRMWARE_CAMPAIGNS_TITLE",

  FETCH_DEVICES_ERROR: "FETCH_DEVICES_ERROR",

  SERIAL_NUMBER_TITLE: "SERIAL_NUMBER_TITLE",
  CODENTIFY_TITLE: "CODENTIFY_TITLE",
  FIRMWARE_VERSION_TITLE: "FIRMWARE_VERSION_TITLE",
  FIRMWARE_UPDATED_TITLE: "FIRMWARE_UPDATED_TITLE",

  DEVICES_FETCH_ERROR: "DEVICES_FETCH_ERROR",
  NO_DEVICES_FOUND: "NO_DEVICES_FOUND",
  CHECK_DEVICE_NUMBER_INFO: "CHECK_DEVICE_NUMBER_INFO",

  SEARCH_FOR_SERIAL_NUMBER: "SEARCH_FOR_SERIAL_NUMBER",
  SEARCH_FOR_FIRMWARE: "SEARCH_FOR_FIRMWARE",
  ERROR_FETCH_DASHBOARDS: "ERROR_FETCH_DASHBOARDS",
  ERROR_GENERATION_DASHBOARD: "ERROR_GENERATION_DASHBOARD",

  ABOUT_DEVICE_TITLE: "ABOUT_DEVICE_TITLE",
  NEW_DEVICE_TITLE: "NEW_DEVICE_TITLE",

  REQUIERED_FIELD_INFO: "REQUIERED_FIELD_INFO",

  DUSN_TITLE: "DUSN_TITLE",
  DUSN_PLACEHOLDER: "DUSN_PLACEHOLDER",

  MODEL_TITLE: "MODEL_TITLE",
  MATERIAL_BRAND_TITLE: "MATERIAL_BRAND_TITLE",
  MATERIAL_COLOR_TITLE: "MATERIAL_COLOR_TITLE",
  MATERIAL_GROUP_TITLE: "MATERIAL_GROUP_TITLE",
  MATERIAL_MODEL_NUMBER_TITLE: "MATERIAL_MODEL_NUMBER_TITLE",

  LATEST_FW_VERSION_TITLE: "LATEST_FW_VERSION_TITLE",

  DATE_OF_UPDATE_TITLE: "DATE_OF_UPDATE_TITLE",
  TIME_OF_UPDATE_TITLE: "TIME_OF_UPDATE_TITLE",

  HARD_RESET_BTN: "HARD_RESET_BTN",
  REMOVE_DEVICE_BTN: "REMOVE_DEVICE_BTN",

  DEVICE_CONTROL_LABEL: "DEVICE_CONTROL_LABEL",
  DEVICE_ENGINE_LABEL: "DEVICE_ENGINE_LABEL",

  HOLDER_CONTROL_LABEL: "HOLDER_CONTROL_LABEL",
  HOLDER_ENGINE_LABEL: "HOLDER_ENGINE_LABEL",

  DISCARD_DEVICE_CREATION_TITLE: "DISCARD_DEVICE_CREATION_TITLE",
  DISCARD_DEVICE_CREATION_TEXT: "DISCARD_DEVICE_CREATION_TEXT",

  DISCARD_DEVICE_EDITION_TITLE: "DISCARD_DEVICE_EDITION_TITLE",
  DISCARD_DEVICE_EDITION_TEXT: "DISCARD_DEVICE_EDITION_TEXT",

  REMOVE_DEVICE_CONFIRMATION_TITLE: "REMOVE_DEVICE_CONFIRMATION_TITLE",
  REMOVE_DEVICE_CONFIRMATION_TEXT: "REMOVE_DEVICE_CONFIRMATION_TEXT",

  HARD_RESET_CONFIRMATION_TITLE: "HARD_RESET_CONFIRMATION_TITLE",
  HARD_RESET_CONFIRMATION_TEXT: "HARD_RESET_CONFIRMATION_TEXT",

  NEW_FIRMWARE_TITLE: "NEW_FIRMWARE_TITLE",
  EDIT_FIRMWARE_TITLE: "EDIT_FIRMWARE_TITLE",
  DEV_TYPE_UNKNOWN: "DEV_TYPE_UNKNOWN",

  DEVICE_NOT_FOUND: "DEVICE_NOT_FOUND",

  DUSN_VALIDATION_ERROR_TITLE: "DUSN_VALIDATION_ERROR_TITLE",
  DUSN_VALIDATION_MODEL_ERROR_INFO: "DUSN_VALIDATION_MODEL_ERROR_INFO",
  DUSN_VALIDATION_TYPE_ERROR_INFO: "DUSN_VALIDATION_TYPE_ERROR_INFO",

  CREATE_DEVICE_SUCCESS: "CREATE_DEVICE_SUCCESS",
  CREATE_DEVICE_SUCCESS_INFO: "CREATE_DEVICE_SUCCESS_INFO",

  CREATE_DEVICE_ERROR: "CREATE_DEVICE_ERROR",

  DELETE_DEVICE_SUCCESS: "DELETE_DEVICE_SUCCESS",
  DELETE_DEVICE_SUCCESS_INFO: "DELETE_DEVICE_SUCCESS_INFO",

  DELETE_DEVICE_ERROR: "DELETE_DEVICE_ERROR",

  RESET_DEVICE_SUCCESS: "RESET_DEVICE_SUCCESS",
  RESET_DEVICE_SUCCESS_INFO: "RESET_DEVICE_SUCCESS_INFO",

  RESET_DEVICE_ERROR: "RESET_DEVICE_ERROR",

  SUCCESSFUL_DEVICES_IMPORT_INFO: "SUCCESSFUL_DEVICES_IMPORT_INFO",
  FAILED_DEVICES_IMPORT_INFO: "FAILED_DEVICES_IMPORT_INFO",

  CREATE_DEVICE_BATCH_SUCCESS: "CREATE_DEVICE_BATCH_SUCCESS",
  CREATE_DEVICE_BATCH_SUCCESS_INFO: "CREATE_DEVICE_BATCH_SUCCESS_INFO",
  CREATE_DEVICE_BATCH_ERROR: "CREATE_DEVICE_BATCH_ERROR",

  SEARCH_FOR_CAMPAIGN: "SEARCH_FOR_CAMPAIGN",

  NOTIFICATIONS_MESSAGE_HINT: "NOTIFICATIONS_MESSAGE_HINT",
  FIRMWARE_HINT: "FIRMWARE_HINT",

  CAMPAIGN_IS_NOT_FOUND: "CAMPAIGN_IS_NOT_FOUND",

  LOADING_PLEASE_WAIT_TITLE: "LOADING_PLEASE_WAIT_TITLE",

  RELEASE_NOTES_TITLE: "RELEASE_NOTES_TITLE",
  RELEASE_NOTES_SLECTOR_LABEL: "RELEASE_NOTES_SLECTOR_LABEL",

  SIMLE_LIST_TITLE: "SIMLE_LIST_TITLE",
  SIMLE_LIST_DESCRIPTION: "SIMLE_LIST_DESCRIPTION",
  LIST_WITH_ICONS_TITLE: "LIST_WITH_ICONS_TITLE",
  LIST_WITH_ICONS_DESCRIPTION: "LIST_WITH_ICONS_DESCRIPTION",
  CAROUSEL_TITLE: "CAROUSEL_TITLE",
  CAROUSEL_DESCRIPTION: "CAROUSEL_DESCRIPTION",
  RICH_RELEASE_NOTES_TITLE: "RICH_RELEASE_NOTES_TITLE",

  NEW_FEATURES_TITLE: "NEW_FEATURES_TITLE",
  IMPROVEMENTS_TITLE: "IMPROVEMENTS_TITLE",
  BULLET_LIST_PLACEHOLDER: "BULLET_LIST_PLACEHOLDER",
  MISSING_CONTENT_INFO: "MISSING_CONTENT_INFO",

  MEDIA_TITLE: "MEDIA_TITLE",
  THUMBNAIL_TITLE: "THUMBNAIL_TITLE",

  SHORT_DESCRIPTION_TITLE: "SHORT_DESCRIPTION_TITLE",
  ENTER_TITLE_PLACEHOLDER: "ENTER_TITLE_PLACEHOLDER",
  ENTER_DESCRIPTION_PLACEHOLDER: "ENTER_DESCRIPTION_PLACEHOLDER",

  LINK_TEXT_TITLE: "LINK_TEXT_TITLE",
  LINK_TITLE: "LINK_TITLE",
  ADD_LINK_BTN: "ADD_LINK_BTN",

  RELEASE_NOTE_GLOBAL_INFO: "RELEASE_NOTE_GLOBAL_INFO",

  SUMMARY_OF_CHANGES_TITLE: "SUMMARY_OF_CHANGES_TITLE",
  ADD_SUMMARY_BTN: "ADD_SUMMARY_BTN",

  REMOVE_ICON_CONFIRMATION_TITLE: "REMOVE_ICON_CONFIRMATION_TITLE",
  REMOVE_ICON_CONFIRMATION_TEXT: "REMOVE_ICON_CONFIRMATION_TEXT",

  DONT_SHOW_AGAIN_INFO: "DONT_SHOW_AGAIN_INFO",

  YES_REMOVE_BTN: "YES_REMOVE_BTN",

  UNSUPPORTED_MEDIA_FORMAT_INFO: "UNSUPPORTED_MEDIA_FORMAT_INFO",

  CHANGE_TYPE_TITLE: "CHANGE_TYPE_TITLE",
  CHANGE_TYPE_DESCRIPTION: "CHANGE_TYPE_DESCRIPTION",

  YES_CHANGE_BTN: "YES_CHANGE_BTN",
  ADD_NEW_ITEM_TOOLTIP: "ADD_NEW_ITEM_TOOLTIP",
  REMOVE: "REMOVE",

  CREATED_DATE_TITLE: "CREATED_DATE_TITLE",

  USER_INACTIVE_ERROR_TITLE: "USER_INACTIVE_ERROR_TITLE",
  USER_INACTIVE_ERROR_MESSAGE: "USER_INACTIVE_ERROR_MESSAGE",

  DELETE_APP_CONFIRMATION_TITLE: "DELETE_APP_CONFIRMATION_TITLE",
  DELETE_APP_CONFIRMATION_TEXT: "DELETE_APP_CONFIRMATION_TEXT",
  DELETE_APP_SUCCESS_TITLE: "DELETE_APP_SUCCESS_TITLE",
  DELETE_APP_SUCCESS_TEXT: "DELETE_APP_SUCCESS_TEXT",
  DELETE_APP_ERROR_TITLE: "DELETE_APP_ERROR_TITLE",

  RELEASE_NOTE_PREVIEW_TITLE: "RELEASE_NOTE_PREVIEW_TITLE",

  FETCH_RELEASE_NOTES_ERROR: "FETCH_RELEASE_NOTES_ERROR",
  CREATE_RELEASE_NOTES_ERROR: "CREATE_RELEASE_NOTES_ERROR",
  UPDATE_RELEASE_NOTES_ERROR: "UPDATE_RELEASE_NOTES_ERROR",
  DELETE_RELEASE_NOTES_ERROR: "DELETE_RELEASE_NOTES_ERROR",

  RELEASE_NOTES_ICON_UPLOAD_ERROR: "RELEASE_NOTES_ICON_UPLOAD_ERROR",

  RELEASE_NOTES_PREVIEW_TITLE: "RELEASE_NOTES_PREVIEW_TITLE",
  CUSTOM_TITLE: "CUSTOM_TITLE",
  NO_CUSTOM_FEATURES_YET: "NO_CUSTOM_FEATURES_YET",
  ENTER_NAME_PLACEHOLDER: "ENTER_NAME_PLACEHOLDER",
  ENTER_VALUE_PLACEHOLDER: "ENTER_VALUE_PLACEHOLDER",

  INFORMATION_TITLE: "INFORMATION_TITLE",
  CERTIFICATES_TITLE: "CERTIFICATES_TITLE",

  GET_CERTIFICATE_TITLE: "GET_CERTIFICATE_TITLE",
  GET_CERTIFICATE_DESCRIPTION: "GET_CERTIFICATE_DESCRIPTION",
  GENERATED_CERTIFICATE_DESCRIPTION: "GENERATED_CERTIFICATE_DESCRIPTION",

  GENERATE_BTN: "GENERATE_BTN",
  REVOKE_BTN: "REVOKE_BTN",

  CREATE_CERTIFICATES_SUCCESS: "CREATE_CERTIFICATES_SUCCESS",
  CREATE_CERTIFICATES_SUCCESS_INFO: "CREATE_CERTIFICATES_SUCCESS_INFO",
  CREATE_CERTIFICATES_ERROR: "CREATE_CERTIFICATES_ERROR",
  DOWNLOAD_CERTIFICATES_ERROR: "DOWNLOAD_CERTIFICATES_ERROR",
  FETCH_DEVICE_CERTIFICATE_ERROR: "FETCH_DEVICE_CERTIFICATE_ERROR",
  FETCH_DEVICE_CHANGE_HISTORY_ERROR: "FETCH_DEVICE_CHANGE_HISTORY_ERROR",

  GENERATE_ACTION: "GENERATE_ACTION",
  DOWNLOAD_ACTION: "DOWNLOAD_ACTION",
  REVOKE_ACTION: "REVOKE_ACTION",

  CERTIFICATES_TITTLE: "CERTIFICATES_TITTLE",
  CHOOSE_ACTION_TITLE: "CHOOSE_ACTION_TITLE",

  GENERATE_DESCRIPTION: "GENERATE_DESCRIPTION",
  DOWNLOAD_DESCRIPTION: "DOWNLOAD_DESCRIPTION",
  REVOKE_DESCRIPTION: "REVOKE_DESCRIPTION",
  NO_SKIP_THOSE_BTN: "NO_SKIP_THOSE_BTN",

  GENERATE_CERTIFICATES_TITLE: "GENERATE_CERTIFICATES_TITLE",
  DOWNLOAD_CERTIFICATES_TITLE: "DOWNLOAD_CERTIFICATES_TITLE",
  REVOKE_CERTIFICATES_TITLE: "REVOKE_CERTIFICATES_TITLE",
  REVOKE_CERTIFICATE_TITLE: "REVOKE_CERTIFICATE_TITLE",
  DOWNLOADING_INFO: "DOWNLOADING_INFO",

  GENERATE_CERTIFICATES: "GENERATE_CERTIFICATES",
  DOWNLOAD_CERTIFICATES: "DOWNLOAD_CERTIFICATES",
  REVOKE_CERTIFICATES: "REVOKE_CERTIFICATES",

  CERTIFICATE_CREATED_BY_TITLE: "CERTIFICATE_CREATED_BY_TITLE",
  EXPIRATION_DATE_TITLE: "EXPIRATION_DATE_TITLE",
  REVOKE_WARNING_MSG: "REVOKE_WARNING_MSG",
  DEVICES_IMPORT_INFO_SUCCESS: "DEVICES_IMPORT_INFO_SUCCESS",
  RECORDS_UPLOAD_SUCCESS: "RECORDS_UPLOAD_SUCCESS",
  GENERATE_CERTIFICATES_TOOLTIP: "Certificates will be created only for supported devices",
  CERTIFICATES_VALID_UNTIL: "CERTIFICATES_VALID_UNTIL",

  INCORRECT_DEVICES_INFO: "INCORRECT_DEVICES_INFO",
  INCORRECT_DEVICE_INFO: "INCORRECT_DEVICE_INFO",

  REQUEST_BODY_IS_NOT_PROVIDED: "REQUEST_BODY_IS_NOT_PROVIDED",
  INVALID_DUSN_VALUE: "INVALID_DUSN_VALUE",

  DUPLICATE_TO_ANOTHER_LOCATION: "DUPLICATE_TO_ANOTHER_LOCATION",
  DUPLICATE_HERE: "DUPLICATE_HERE",
  PROCEED_BTN: "PROCEED_BTN",
  REVOKE_DEVICE_CERTIFICATE_WARNING_MSG: "REVOKE_DEVICE_CERTIFICATE_WARNING_MSG",

  DEFAULT_LANGUAGE_WRANING_MSG: "DEFAULT_LANGUAGE_WRANING_MSG",

  REMOVE_APP_LOCALIZATION_TITLE: "REMOVE_APP_LOCALIZATION_TITLE",
  REMOVE_APP_LOCALIZATION_INFO: "REMOVE_APP_LOCALIZATION_INFO",
  ROLES_LINK_INFO: "ROLES_LINK_INFO",

  USER_GROUP_TITLE: "USER_GROUP_TITLE",
  GROUP_SETTINGS_TOOLTIP: "GROUP_SETTINGS_TOOLTIP",
  GROUP_SETTINGS_TITLE: "GROUP_SETTINGS_TITLE",
  SEARCH_GROUPS_PLACEHOLDER: "SEARCH_GROUPS_PLACEHOLDER",
  NO_GROUPS_YET: "NO_GROUPS_YET",
  ADD_GROUP_TITLE: "ADD_GROUP_TITLE",
  ALL_APPS_TITLE: "ALL_APPS_TITLE",
  ALL_MARKETS_TITLE: "ALL_MARKETS_TITLE",
  ALL_GROUPS_TITLE: "ALL_GROUPS_TITLE",
  ALL_STATUSES_TITLE: "ALL_STATUSES_TITLE",
  ACTIVE_STATUSES_TITLE: "ACTIVE_STATUSES_TITLE",
  INACTIVE_STATUSES_TITLE: "INACTIVE_STATUSES_TITLE",
  CLEAR_BTN: "CLEAR_BTN",
  NEW_GROUP: "NEW_GROUP",
  FETCH_GROUPS_ERROR: "FETCH_GROUPS_ERROR",
  APPS_SEARCH_TITLE: "APPS_SEARCH_TITLE",
  APPS_SEARCH_PLACEHOLDER: "APPS_SEARCH_PLACEHOLDER",
  APPS_SEARCH_DESCRIPTION: "APPS_SEARCH_DESCRIPTION",
  MARKETS_SEARCH_TITLE: "MARKETS_SEARCH_TITLE",
  MARKETS_SEARCH_PLACEHOLDER: "MARKETS_SEARCH_PLACEHOLDER",
  MARKETS_SEARCH_DESCRIPTION: "MARKETS_SEARCH_DESCRIPTION",
  GROUP_SEARCH_TITLE: "GROUP_SEARCH_TITLE",
  GROUP_SEARCH_DESCRIPTION: "GROUP_SEARCH_DESCRIPTION",
  APP_NAMES: "APP_NAMES",
  MARKET_NAMES: "MARKET_NAMES",
  GROUP_NAMES: "GROUP_NAMES",
  GROUP_ALREADY_EXIST_ERROR: "GROUP_ALREADY_EXIST_ERROR",
  GROUP_EDIT_ERROR: "GROUP_EDIT_ERROR",
  GROUP_PlACEHOLDER: "GROUP_PlACEHOLDER",

  VERSION: "VERSION",
  COMPONENT: "COMPONENT",
  AUTHOR: "AUTHOR",
  LICENSES_TABLE_TITLE: "LICENSES_TABLE_TITLE",
  MIT_DEFINITION: "MIT_DEFINITION",
  MIT_URL: "MIT_URL",
  APACHE_2_0_URL: "APACHE_2_0_URL",
  CC0_1_0_URL: "CC0_1_0_URL",
  BSD_3_Clause_URL: "BSD_3_Clause_URL",
  ISC_URL: "ISC_URL",
  BSD_2_Clause_URL: "BSD_2_Clause_URL",
  MPL_2_0_URL: "MPL_2_0_URL",
  CC_BY_4_0_URL: "CC_BY_4_0_URL",
  BSD_URL: "BSD_URL",
  MPL_1_1_URL: "MPL_1_1_URL",
  _0BSD_URL: "_0BSD_URL",
  GPL_2_0_URL: "GPL_2_0_URL",
  EPL_1_0_URL: "EPL_1_0_URL",
  Zlib_URL: "Zlib_URL",
  WTFPL_URL: "WTFPL_URL",
  CC_BY_3_0_URL: "CC_BY_3_0_URL",
  LICENSES: "LICENSES",
  PYTHON_2_0_URL: "PYTHON_2_0_URL",
  GPL_3_0_URL: "GPL_3_0_URL",

  SOFTWARE_UPDATE_TITLE: "SOFTWARE_UPDATE_TITLE",
  RELEASE_NOTES_VERSION_INFO: "RELEASE_NOTES_VERSION_INFO",

  ALL_DEVICE_TYPES_LABEL: "ALL_DEVICE_TYPES_LABEL",
  DEVICE_SEARCH_TITLE: "DEVICE_SEARCH_TITLE",
  DEVICE_SEARCH_PLACEHOLDER: "DEVICE_SEARCH_PLACEHOLDER",
  DEVICE_SEARCH_DESCRIPTION: "DEVICE_SEARCH_DESCRIPTION",
  MANAGE_GROUPS_TITLE: "MANAGE_GROUPS_TITLE",
  RETURN_TO_DEVICE_BTN: "RETURN_TO_DEVICE_BTN",

  FETCH_DEVICE_GROUPS_ERROR: "FETCH_DEVICE_GROUPS_ERROR",
  CREATE_DEVICE_GROUP_ERROR: "CREATE_DEVICE_GROUP_ERROR",
  UPDATE_DEVICE_GROUP_ERROR: "UPDATE_DEVICE_GROUP_ERROR",
  DELETE_DEVICE_GROUP_ERROR: "DELETE_DEVICE_GROUP_ERROR",
  FETCH_DEVICE_GROUPS_LIST_ERROR: "FETCH_DEVICE_GROUPS_LIST_ERROR",
  UPDATE_DEVICE_GROUPS_LIST_ERROR: "UPDATE_DEVICE_GROUPS_LIST_ERROR",

  GROUP_IDS_ALREADY_EXISTS: "GROUP_IDS_ALREADY_EXISTS",

  ACTIVE_APP_TITLE: "ACTIVE_APP_TITLE",
  ACTIVE_APP_DESCRIPTION: "ACTIVE_APP_DESCRIPTION",

  PRESET_TITLE: "PRESET_TITLE",

  REMOVE_APP_MARKET_CONFIRMATION_TITLE: "REMOVE_APP_MARKET_CONFIRMATION_TITLE",
  REMOVE_APP_MARKET_CONFIRMATION_TEXT: "REMOVE_APP_MARKET_CONFIRMATION_TEXT",

  RELATED_DUSN_TITLE: "RELATED_DUSN_TITLE",
  KIT_CODENTIFY_TITLE: "KIT_CODENTIFY_TITLE",

  FETCH_DEVICE_KIT_LIST_ERROR: "FETCH_DEVICE_KIT_LIST_ERROR",
  CREATE_DEVICE_KIT_ERROR: "CREATE_DEVICE_KIT_ERROR",

  DEVICE_ALREADY_CONNECTED_TO_KIT: "DEVICE_ALREADY_CONNECTED_TO_KIT",
  DEVICE_KIT_ALREADY_FULL: "DEVICE_KIT_ALREADY_FULL",

  HARDWARES_TITLE: "HARDWARES_TITLE",

  ID_TITLE: "ID_TITLE",
  SSID_TITLE: "SSID_TITLE",
  MAC_ADDRESS_TITLE: "MAC_ADDRESS_TITLE",

  ASSIGN_BTN: "ASSIGN_BTN",
  REASSIGN_BTN: "REASSIGN_BTN",

  PETIOLE_TITLE: "PETIOLE_TITLE",
  MERCURY_TITLE: "MERCURY_TITLE",

  VIEW_BY_HARDWARE: "VIEW_BY_HARDWARE",
  VIEW_BY_LOCATIONS: "VIEW_BY_LOCATIONS",

  HARDWARE_FETCH_ERROR: "HARDWARE_FETCH_ERROR",
  NO_HARDWARE_FOUND: "NO_HARDWARE_FOUND",
  CHECK_HARDWARE_ID_INFO: "CHECK_HARDWARE_ID_INFO",
  NO_LOCATIONS_FOUND: "NO_LOCATIONS_FOUND",
  CHECK_LOCATION_NAME_INFO: "CHECK_LOCATION_NAME_INFO",

  UNASSIGNED_INFO: "UNASSIGNED_INFO",
  NA_INFO: "NA_INFO",
  NO_ASSIGNED_HARDWARES_INFO: "NO_ASSIGNED_HARDWARES_INFO",

  ASSIGN_HARDWARE_ID: "ASSIGN_HARDWARE_ID",
  SELECT_HARDWARE_LOCATION_TITLE: "SELECT_HARDWARE_LOCATION_TITLE",
  UNASSIGN_BTN: "UNASSIGN_BTN",

  SELECT_LOCATION_HARDWARE_TITLE: "SELECT_LOCATION_HARDWARE_TITLE",
  HARDWARE_IDS_PLACEHOLDER: "HARDWARE_IDS_PLACEHOLDER",
  HARDWARE_SSIDS_PLACEHOLDER: "HARDWARE_SSIDS_PLACEHOLDER",
  UNASSIGN_ALL_BTN: "UNASSIGN_ALL_BTN",

  NEW_ROUTER_TITLE: "NEW_ROUTER_TITLE",

  SSID_FULL_TITLE: "SSID_FULL_TITLE",
  SSID_PLACEHOLDER: "SSID_PLACEHOLDER",
  MAC_ADDRESS_PLACEHOLDER: "MAC_ADDRESS_PLACEHOLDER",
  ASSIGNED_LOCATION_TITLE: "ASSIGNED_LOCATION_TITLE",
  CHOOSE_LOCATION_PLACEHOLDER: "CHOOSE_LOCATION_PLACEHOLDER",

  FETCH_HARDWARE_ERROR: "FETCH_HARDWARE_ERROR",
  UPDATE_HARDWARE_LOCATION_SUCCESS: "UPDATE_HARDWARE_LOCATION_SUCCESS",
  UPDATE_HARDWARE_LOCATION_SUCCESS_INFO: "UPDATE_HARDWARE_LOCATION_SUCCESS_INFO",
  UPDATE_HARDWARE_LOCATION_ERROR: "UPDATE_HARDWARE_LOCATION_ERROR",
  UPDATE_LOCATION_HARDWARE_SUCCESS: "UPDATE_LOCATION_HARDWARE_SUCCESS",
  UPDATE_LOCATION_HARDWARE_SUCCESS_INFO: "UPDATE_LOCATION_HARDWARE_SUCCESS_INFO",
  UPDATE_LOCATION_HARDWARE_ERROR: "UPDATE_LOCATION_HARDWARE_ERROR",

  USER_INSIGHTS_NAV_BTN: "USER_INSIGHTS_NAV_BTN",

  NO_USER_INSIGHTS_FOUND: "NO_USER_INSIGHTS_FOUND",

  RERUN_SEGMENTATION_BTN: "RERUN_SEGMENTATION_BTN",
  EXPORT_BTN: "EXPORT_BTN",

  SEGMENT_TITLE: "SEGMENT_TITLE",
  CONVERSION_TYPE_TITLE: "CONVERSION_TYPE_TITLE",
  USER_SINCE_TITLE: "USER_SINCE_TITLE",

  REGULAR_SEGMENT_TITLE: "REGULAR_SEGMENT_TITLE",
  CHILLED_SEGMENT_TITLE: "CHILLED_SEGMENT_TITLE",
  SPRINT_SEGMENT_TITLE: "SPRINT_SEGMENT_TITLE",
  MILD_SEGMENT_TITLE: "MILD_SEGMENT_TITLE",
  ALERT_SEGMENT_TITLE: "ALERT_SEGMENT_TITLE",
  TRIED_BUT_FAILED_SEGMENT_TITLE: "TRIED_BUT_FAILED_SEGMENT_TITLE",
  NEVER_TRIED_SEGMENT_TITLE: "NEVER_TRIED_SEGMENT_TITLE",

  REGULAR_SEGMENT_DESCRIPTION: "REGULAR_SEGMENT_DESCRIPTION",
  CHILLED_SEGMENT_DESCRIPTION: "CHILLED_SEGMENT_DESCRIPTION",
  SPRINT_SEGMENT_DESCRIPTION: "SPRINT_SEGMENT_DESCRIPTION",
  MILD_SEGMENT_DESCRIPTION: "MILD_SEGMENT_DESCRIPTION",
  ALERT_SEGMENT_DESCRIPTION: "ALERT_SEGMENT_DESCRIPTION",

  CONVERSION_TITLE: "CONVERSION_TITLE",
  NON_CONVERSION_TITLE: "NON_CONVERSION_TITLE",
  ALL_CONVERSION_TYPES: "ALL_CONVERSION_TYPES",

  CONNECTED_TITLE: "CONNECTED_TITLE",
  NOT_CONNECTED_TITLE: "NOT_CONNECTED_TITLE",

  ALL_SEGMENTS_OPTION: "ALL_SEGMENTS_OPTION",
  SEGMENTS_FILTER_TITLE: "SEGMENTS_FILTER_TITLE",
  SEGMENTS_FILTER_TEXT: "SEGMENTS_FILTER_TEXT",

  EXPORT_TABLE_TITLE: "EXPORT_TABLE_TITLE",
  INCLUDE_FILTERS_LABEL: "INCLUDE_FILTERS_LABEL",

  TOTAL_USERS_TITLE: "TOTAL_USERS_TITLE",
  CONNECTED_USERS_TITLE: "CONNECTED_USERS_TITLE",
  SEGMENTATION_TITLE: "SEGMENTATION_TITLE",

  LAST_SEGMENTED_INFO: "LAST_SEGMENTED_INFO",
  CREATE_HARDWARE_SUCCESS: "CREATE_HARDWARE_SUCCESS",
  CREATE_HARDWARE_SUCCESS_INFO: "CREATE_HARDWARE_SUCCESS_INFO",
  CREATE_HARDWARE_ERROR: "CREATE_HARDWARE_ERROR",

  VALID_UNTIL_INFO: "VALID_UNTIL_INFO",
  EXPIRED_INFO: "EXPIRED_INFO",
  NO_USER_ROLES_INFO: "NO_USER_ROLES_INFO",
  SET_UP_ROLE_BTN: "SET_UP_ROLE_BTN",

  DELETE_ROLE_TITLE: "DELETE_ROLE_TITLE",
  DELETE_ROLE_TEXT: "DELETE_ROLE_TEXT",

  ADMIN_USER: "ADMIN_USER",
  REGULAR_USER: "REGULAR_USER",

  SESSION_CLOSED_MESSAGE: "SESSION_CLOSED_MESSAGE",

  CHANNEL_TITLE: "CHANNEL_TITLE",
  CONSUMER_CHANNEL: "CONSUMER_CHANNEL",
  COACH_CHANNEL: "COACH_CHANNEL"
};
